// import { Fragment, useEffect, useState } from "react"
// import { Modal, Spinner, Button, Form, Row, Col, Alert } from "react-bootstrap"
// import axios from "axios"
// import { useUserState } from "../../../Contexts/UserContext"
// import LocationSelectorMap from "@common/LocationSelectorMap"
// import GoogleMapsSelector from "@common/GoogleMapsSelector"

// const tabs = [
//   { id: "profile", name: "Profile Setup" },
//   { id: "delivery", name: "Delivery Fee" },
// ]

// // Configuration - set your Google Maps API key here
// const Maps_API_KEY = import.meta.env.VITE_Maps_API_KEY || "";
// const USE_Maps = !!Maps_API_KEY // Use Google Maps if API key is available

// const FurnitureDeliverySetup = () => {
//   const { user } = useUserState()
//   const [activeTab, setActiveTab] = useState("profile")
//   const [isLoader, setIsLoader] = useState(false)
//   const [saveLoader, setSaveLoader] = useState(false)

//   // Company Profile State
//   const [companyProfile, setCompanyProfile] = useState({
//     name: "",
//     description: "",
//     address: "",
//     city: "",
//     state: "",
//     zip_code: "",
//     country: "",
//     latitude: "",
//     longitude: "",
//   })

//   // Delivery Ranges State
//   const [deliveryRanges, setDeliveryRanges] = useState([])
//   const [newRange, setNewRange] = useState({
//     min_range: "",
//     max_range: "",
//     price: "",
//     extra_fee: "",
//   })

//   // City Pricing State
//   const [cityPricing, setCityPricing] = useState({})
//   const [showCityForm, setShowCityForm] = useState({})
//   const [newCityPrice, setNewCityPrice] = useState({
//     city_name: "",
//     extra_price: "",
//   })

//   // Error and Success States
//   const [error, setError] = useState("")
//   const [success, setSuccess] = useState("")
//   const [deleteModal, setDeleteModal] = useState(false)
//   const [deleteRangeId, setDeleteRangeId] = useState("")
//   const [delLoader, setDelLoader] = useState(false)

//   // Map visibility state
//   const [showMap, setShowMap] = useState(false)

//   // Handle location change from map component
//   const handleLocationChange = locationData => {
//     setCompanyProfile(prev => ({
//       ...prev,
//       latitude: locationData.latitude,
//       longitude: locationData.longitude,
//       address: locationData.address || prev.address,
//       city: locationData.city || prev.city,
//       state: locationData.state || prev.state,
//       country: locationData.country || prev.country,
//       zip_code: locationData.zipCode || prev.zip_code,
//     }))
//   }

//   // Handle address change from map component
//   const handleAddressChange = address => {
//     setCompanyProfile(prev => ({
//       ...prev,
//       address: address,
//     }))
//   }

//   // Fetch company profile
//   const getCompanyProfile = async () => {
//     const headers = {
//       "Content-Type": "application/json",
//       Authorization: user?.token,
//     }

//     if (user?.token) {
//       setIsLoader(true)
//       try {
//         const res = await axios.get(`${import.meta.env.VITE_APP_BASE_URL}/api/company/profile`, { headers })
//         if (res.data?.data) {
//           setCompanyProfile(res.data.data)
//         }
//         setIsLoader(false)
//       } catch (err) {
//         console.log(err)
//         setIsLoader(false)
//       }
//     }
//   }

//   // Fetch delivery ranges
//   const getDeliveryRanges = async () => {
//     const headers = {
//       "Content-Type": "application/json",
//       Authorization: user?.token,
//     }

//     if (user?.token) {
//       setIsLoader(true)
//       try {
//         const res = await axios.get(`${import.meta.env.VITE_APP_BASE_URL}/api/delivery/ranges`, { headers })
//         if (res.data?.data) {
//           setDeliveryRanges(res.data.data)
//           // Fetch city pricing for each range
//           res.data.data.forEach(range => {
//             getCityPricing(range.id)
//           })
//         }
//         setIsLoader(false)
//       } catch (err) {
//         console.log(err)
//         setIsLoader(false)
//       }
//     }
//   }

//   // Fetch city pricing for a specific range
//   const getCityPricing = async rangeId => {
//     const headers = {
//       "Content-Type": "application/json",
//       Authorization: user?.token,
//     }

//     try {
//       const res = await axios.get(`${import.meta.env.VITE_APP_BASE_URL}/api/delivery/city-pricing/${rangeId}`, {
//         headers,
//       })
//       if (res.data?.data) {
//         setCityPricing(prev => ({
//           ...prev,
//           [rangeId]: res.data.data,
//         }))
//       }
//     } catch (err) {
//       console.log(err)
//     }
//   }

//   // Save company profile
//   const saveCompanyProfile = async () => {
//     const headers = {
//       "Content-Type": "application/json",
//       Authorization: user?.token,
//     }

//     setSaveLoader(true)
//     setError("")
//     setSuccess("")

//     try {
//       const res = await axios.post(`${import.meta.env.VITE_APP_BASE_URL}/api/company/profile`, companyProfile, {
//         headers,
//       })

//       if (res.data?.success) {
//         setSuccess("Company profile saved successfully!")
//         setTimeout(() => setSuccess(""), 3000)
//       }
//       setSaveLoader(false)
//     } catch (err) {
//       setError(err.response?.data?.message || "Failed to save profile")
//       setSaveLoader(false)
//     }
//   }

//   // Validate range continuity
//   const validateRangeContinuity = (newFromMiles, newToMiles) => {
//     const sortedRanges = [...deliveryRanges].sort((a, b) => a.min_range - b.min_range)

//     // Check if new range creates gaps or overlaps
//     for (let i = 0; i < sortedRanges.length; i++) {
//       const range = sortedRanges[i]

//       // Check for overlaps
//       if (
//         (newFromMiles >= range.min_range && newFromMiles < range.max_range) ||
//         (newToMiles > range.min_range && newToMiles <= range.max_range) ||
//         (newFromMiles <= range.min_range && newToMiles >= range.max_range)
//       ) {
//         return "Range overlaps with existing range"
//       }
//     }

//     // Check for gaps
//     if (sortedRanges.length > 0) {
//       const lastRange = sortedRanges[sortedRanges.length - 1]
//       if (newFromMiles !== lastRange.max_range && newFromMiles !== 0) {
//         return "Range must be continuous. Start from where the last range ended."
//       }
//     }

//     return null
//   }

//   // Add delivery range
//   const addDeliveryRange = async () => {
//     const { min_range, max_range, price, extra_fee } = newRange

//     if (!min_range || !max_range || !price) {
//       setError("Please fill all required fields")
//       return
//     }

//     if (Number.parseInt(min_range) >= Number.parseInt(max_range)) {
//       setError("To miles must be greater than from miles")
//       return
//     }

//     const validationError = validateRangeContinuity(Number.parseInt(min_range), Number.parseInt(max_range))
//     if (validationError) {
//       setError(validationError)
//       return
//     }

//     const headers = {
//       "Content-Type": "application/json",
//       Authorization: user?.token,
//     }

//     setSaveLoader(true)
//     setError("")

//     try {
//       const res = await axios.post(
//         `${import.meta.env.VITE_APP_BASE_URL}/api/delivery/ranges`,
//         {
//           min_range: Number.parseInt(min_range),
//           max_range: Number.parseInt(max_range),
//           price: Number.parseFloat(price),
//           extra_fee: Number.parseFloat(extra_fee) || 0,
//         },
//         { headers }
//       )

//       if (res.data?.success) {
//         setSuccess("Delivery range added successfully!")
//         setNewRange({ min_range: "", max_range: "", price: "", extra_fee: "" })
//         getDeliveryRanges()
//         setTimeout(() => setSuccess(""), 3000)
//       }
//       setSaveLoader(false)
//     } catch (err) {
//       setError(err.response?.data?.message || "Failed to add delivery range")
//       setSaveLoader(false)
//     }
//   }

//   // Delete delivery range
//   const deleteDeliveryRange = async () => {
//     const headers = {
//       "Content-Type": "application/json",
//       Authorization: user?.token,
//     }

//     setDelLoader(true)
//     try {
//       const res = await axios.delete(`${import.meta.env.VITE_APP_BASE_URL}/api/delivery/ranges/${deleteRangeId}`, {
//         headers,
//       })

//       if (res.data?.success) {
//         getDeliveryRanges()
//         setDeleteModal(false)
//         setSuccess("Delivery range deleted successfully!")
//         setTimeout(() => setSuccess(""), 3000)
//       }
//       setDelLoader(false)
//     } catch (err) {
//       setError(err.response?.data?.message || "Failed to delete range")
//       setDelLoader(false)
//     }
//   }

//   // Add city pricing
//   const addCityPricing = async rangeId => {
//     const { city_name, extra_price } = newCityPrice

//     if (!city_name || !extra_price) {
//       setError("Please fill all city pricing fields")
//       return
//     }

//     const headers = {
//       "Content-Type": "application/json",
//       Authorization: user?.token,
//     }

//     setSaveLoader(true)
//     setError("")

//     try {
//       const res = await axios.post(
//         `${import.meta.env.VITE_APP_BASE_URL}/api/delivery/city-pricing`,
//         {
//           range_id: rangeId,
//           city_name,
//           extra_price: Number.parseFloat(extra_price),
//         },
//         { headers }
//       )

//       if (res.data?.success) {
//         setSuccess("City pricing added successfully!")
//         setNewCityPrice({ city_name: "", extra_price: "" })
//         setShowCityForm(prev => ({ ...prev, [rangeId]: false }))
//         getCityPricing(rangeId)
//         setTimeout(() => setSuccess(""), 3000)
//       }
//       setSaveLoader(false)
//     } catch (err) {
//       setError(err.response?.data?.message || "Failed to add city pricing")
//       setSaveLoader(false)
//     }
//   }

//   // Get next range start value
//   const getNextRangeStart = () => {
//     if (deliveryRanges.length === 0) return 0
//     const sortedRanges = [...deliveryRanges].sort((a, b) => a.min_range - b.min_range)
//     return sortedRanges[sortedRanges.length - 1].max_range
//   }

//   useEffect(() => {
//     if (activeTab === "profile") {
//       getCompanyProfile()
//     } else if (activeTab === "delivery") {
//       getDeliveryRanges()
//     }
//   }, [activeTab, user?.token])

//   useEffect(() => {
//     const nextStart = getNextRangeStart()
//     setNewRange(prev => ({ ...prev, min_range: nextStart.toString() }))
//   }, [deliveryRanges])

//   return (
//     <Fragment>
//       <div className="main-box">
//         <div className="content-header">
//           <h3>Furniture Delivery Setup</h3>

//         </div>

//         {error && <Alert variant="danger">{error}</Alert>}
//         {success && <Alert variant="success">{success}</Alert>}

//         <div className="myfurnit_store_main">
//           <ul className="nav nav-tabs" id="myTab" role="tablist">
//             {tabs.map(tab => (
//               <li className="nav-item" role="presentation" key={tab.id}>
//                 <button
//                   className={`nav-link ${activeTab === tab.id ? "active" : ""}`}
//                   type="button"
//                   onClick={() => setActiveTab(tab.id)}
//                 >
//                   {tab.name}
//                 </button>
//               </li>
//             ))}
//           </ul>

//           <div className="tab-content" id="myTabContent">
//             <div className="tab-pane fade show active" role="tabpanel">
//               {isLoader ? (
//                 <div className="eye-loader-frame m-5 p-5">
//                   <div className="eye-loader-spinner"></div>
//                 </div>
//               ) : (
//                 <>
//                   {activeTab === "profile" && (
//                     <div className="company-profile-form p-4">
//                       <h4>Company Profile Information</h4>
//                       <Form>
//                         <Row>
//                           <Col md={6}>
//                             <Form.Group className="mb-3">
//                               <Form.Label>Company Name *</Form.Label>
//                               <Form.Control
//                                 type="text"
//                                 value={companyProfile.name}
//                                 onChange={e => setCompanyProfile(prev => ({ ...prev, name: e.target.value }))}
//                                 placeholder="Enter company name"
//                               />
//                             </Form.Group>
//                           </Col>
//                           <Col md={6}>
//                             <Form.Group className="mb-3">
//                               <Form.Label>City *</Form.Label>
//                               <Form.Control
//                                 type="text"
//                                 value={companyProfile.city}
//                                 onChange={e => setCompanyProfile(prev => ({ ...prev, city: e.target.value }))}
//                                 placeholder="Enter city"
//                               />
//                             </Form.Group>
//                           </Col>
//                         </Row>

//                         {/* <Form.Group className="mb-3">
//                           <Form.Label>Description</Form.Label>
//                           <Form.Control
//                             as="textarea"
//                             rows={3}
//                             value={companyProfile.description}
//                             onChange={e => setCompanyProfile(prev => ({ ...prev, description: e.target.value }))}
//                             placeholder="Enter company description"
//                           />
//                         </Form.Group> */}

//                         <Form.Group className="mb-3">
//                           <Form.Label>Address</Form.Label>
//                           <Form.Control
//                             type="text"
//                             value={companyProfile.address}
//                             onChange={e => setCompanyProfile(prev => ({ ...prev, address: e.target.value }))}
//                             placeholder="Enter full address"
//                           />
//                         </Form.Group>

//                         <Row>
//                           <Col md={4}>
//                             <Form.Group className="mb-3">
//                               <Form.Label>State</Form.Label>
//                               <Form.Control
//                                 type="text"
//                                 value={companyProfile.state}
//                                 onChange={e => setCompanyProfile(prev => ({ ...prev, state: e.target.value }))}
//                                 placeholder="Enter state"
//                               />
//                             </Form.Group>
//                           </Col>
//                           <Col md={4}>
//                             <Form.Group className="mb-3">
//                               <Form.Label>ZIP Code</Form.Label>
//                               <Form.Control
//                                 type="text"
//                                 value={companyProfile.zip_code}
//                                 onChange={e => setCompanyProfile(prev => ({ ...prev, zip_code: e.target.value }))}
//                                 placeholder="Enter ZIP code"
//                               />
//                             </Form.Group>
//                           </Col>
//                           <Col md={4}>
//                             <Form.Group className="mb-3">
//                               <Form.Label>Country</Form.Label>
//                               <Form.Control
//                                 type="text"
//                                 value={companyProfile.country}
//                                 onChange={e => setCompanyProfile(prev => ({ ...prev, country: e.target.value }))}
//                                 placeholder="Enter country"
//                               />
//                             </Form.Group>
//                           </Col>
//                         </Row>

//                         {/* Enhanced Location Selection Section */}
//                         <div className="location-section mb-4">
//                           <div className="d-flex justify-content-between align-items-center mb-3">
//                             <h5>Business Location</h5>
//                             <div>

//                               <Button variant="outline-primary" size="sm" onClick={() => setShowMap(!showMap)}>
//                                 {showMap ? "Hide Map" : "📍 Select on Map"}
//                               </Button>
//                             </div>
//                           </div>

//                           {showMap && (
//                             <>
//                               {USE_Maps ? (
//                                 <GoogleMapsSelector
//                                   initialLatitude={companyProfile.latitude}
//                                   initialLongitude={companyProfile.longitude}
//                                   initialAddress={companyProfile.address}
//                                   onLocationChange={handleLocationChange}
//                                   onAddressChange={handleAddressChange}
//                                   googleMapsApiKey={Maps_API_KEY}
//                                   mapHeight="400px"
//                                   className="mb-3"
//                                 />
//                               ) : (
//                                 <LocationSelectorMap
//                                   initialLatitude={companyProfile.latitude}
//                                   initialLongitude={companyProfile.longitude}
//                                   initialAddress={companyProfile.address}
//                                   onLocationChange={handleLocationChange}
//                                   onAddressChange={handleAddressChange}
//                                   showDeliveryZones={deliveryRanges.length > 0}
//                                   deliveryZones={deliveryRanges.map(range => ({
//                                     min_range: range.min_range,
//                                     max_range: range.max_range,
//                                   }))}
//                                   showAddressSearch={true}
//                                   showCurrentLocation={true}
//                                   showCoordinateInputs={true}
//                                   mapHeight="400px"
//                                   className="mb-3"
//                                 />
//                               )}
//                             </>
//                           )}

//                           {!showMap && (
//                             <Row>
//                               <Col md={6}>
//                                 <Form.Group className="mb-3">
//                                   <Form.Label>Latitude</Form.Label>
//                                   <Form.Control
//                                     type="number"
//                                     step="0.00000001"
//                                     value={companyProfile.latitude}
//                                     onChange={e =>
//                                       setCompanyProfile(prev => ({ ...prev, latitude: e.target.value }))
//                                     }
//                                     placeholder="Enter latitude or select on map"
//                                   />
//                                 </Form.Group>
//                               </Col>
//                               <Col md={6}>
//                                 <Form.Group className="mb-3">
//                                   <Form.Label>Longitude</Form.Label>
//                                   <Form.Control
//                                     type="number"
//                                     step="0.00000001"
//                                     value={companyProfile.longitude}
//                                     onChange={e =>
//                                       setCompanyProfile(prev => ({ ...prev, longitude: e.target.value }))
//                                     }
//                                     placeholder="Enter longitude or select on map"
//                                   />
//                                 </Form.Group>
//                               </Col>
//                             </Row>
//                           )}
//                         </div>

//                         <Button variant="primary" onClick={saveCompanyProfile} disabled={saveLoader}>
//                           {saveLoader ? <Spinner size="sm" /> : "Save Profile"}
//                         </Button>
//                       </Form>
//                     </div>
//                   )}

//                   {activeTab === "delivery" && (
//                     <div className="delivery-setup p-4">
//                       <h4>Delivery Fee Setup</h4>

//                       {deliveryRanges.length === 0 ? (
//                         <div className="no-delivery-setup mb-4">
//                           <Alert variant="info">No delivery fees setup yet. Add your first delivery range below.</Alert>
//                         </div>
//                       ) : (
//                         <div className="existing-ranges mb-4">
//                           <h5>Current Delivery Ranges</h5>
//                           {deliveryRanges
//                             .sort((a, b) => a.min_range - b.min_range)
//                             .map((range, index) => (
//                               <div key={range.id} className="range-item border p-3 mb-3 rounded">
//                                 <div className="d-flex justify-content-between align-items-center">
//                                   <div>
//                                     <strong>
//                                       {range.min_range} - {range.max_range} miles
//                                     </strong>
//                                     <span className="ms-3">Base Price: ${range.price}</span>
//                                     {range.extra_fee > 0 && <span className="ms-3">Extra Fee: ${range.extra_fee}</span>}
//                                   </div>
//                                   <Button
//                                     variant="outline-danger"
//                                     size="sm"
//                                     onClick={() => {
//                                       setDeleteRangeId(range.id)
//                                       setDeleteModal(true)
//                                     }}
//                                   >
//                                     🗑️ Delete
//                                   </Button>
//                                 </div>

//                                 {/* City Pricing Section */}
//                                 <div className="city-pricing mt-3">
//                                   <div className="d-flex justify-content-between align-items-center">
//                                     <h6>City-Specific Pricing</h6>
//                                     <Button
//                                       variant="outline-primary"
//                                       size="sm"
//                                       onClick={() =>
//                                         setShowCityForm(prev => ({
//                                           ...prev,
//                                           [range.id]: !prev[range.id],
//                                         }))
//                                       }
//                                     >
//                                       ➕ Add City Price
//                                     </Button>
//                                   </div>

//                                   {cityPricing[range.id] && cityPricing[range.id].length > 0 && (
//                                     <div className="city-list mt-2">
//                                       {cityPricing[range.id].map(city => (
//                                         <div key={city.id} className="city-item d-flex justify-content-between">
//                                           <span>{city.city_name}</span>
//                                           <span>+${city.extra_price}</span>
//                                         </div>
//                                       ))}
//                                     </div>
//                                   )}

//                                   {showCityForm[range.id] && (
//                                     <div className="city-form mt-2">
//                                       <Row>
//                                         <Col md={6}>
//                                           <Form.Control
//                                             type="text"
//                                             placeholder="City name"
//                                             value={newCityPrice.city_name}
//                                             onChange={e =>
//                                               setNewCityPrice(prev => ({
//                                                 ...prev,
//                                                 city_name: e.target.value,
//                                               }))
//                                             }
//                                           />
//                                         </Col>
//                                         <Col md={4}>
//                                           <Form.Control
//                                             type="number"
//                                             step="0.01"
//                                             placeholder="Extra price"
//                                             value={newCityPrice.extra_price}
//                                             onChange={e =>
//                                               setNewCityPrice(prev => ({
//                                                 ...prev,
//                                                 extra_price: e.target.value,
//                                               }))
//                                             }
//                                           />
//                                         </Col>
//                                         <Col md={2}>
//                                           <Button
//                                             variant="success"
//                                             size="sm"
//                                             onClick={() => addCityPricing(range.id)}
//                                             disabled={saveLoader}
//                                           >
//                                             Add
//                                           </Button>
//                                         </Col>
//                                       </Row>
//                                     </div>
//                                   )}
//                                 </div>
//                               </div>
//                             ))}
//                         </div>
//                       )}

//                       {/* Add New Range Form */}
//                       <div className="add-range-form border p-3 rounded">
//                         <h5>Add New Delivery Range</h5>
//                         <Row>
//                           <Col md={2}>
//                             <Form.Group className="mb-3">
//                               <Form.Label>From Miles</Form.Label>
//                               <Form.Control
//                                 type="number"
//                                 value={newRange.min_range}
//                                 onChange={e => setNewRange(prev => ({ ...prev, min_range: e.target.value }))}
//                                 placeholder="0"
//                                 readOnly={deliveryRanges.length > 0}
//                               />
//                             </Form.Group>
//                           </Col>
//                           <Col md={2}>
//                             <Form.Group className="mb-3">
//                               <Form.Label>To Miles</Form.Label>
//                               <Form.Control
//                                 type="number"
//                                 value={newRange.max_range}
//                                 onChange={e => setNewRange(prev => ({ ...prev, max_range: e.target.value }))}
//                                 placeholder="40"
//                               />
//                             </Form.Group>
//                           </Col>
//                           <Col md={3}>
//                             <Form.Group className="mb-3">
//                               <Form.Label>Base Price ($)</Form.Label>
//                               <Form.Control
//                                 type="number"
//                                 step="0.01"
//                                 value={newRange.price}
//                                 onChange={e => setNewRange(prev => ({ ...prev, price: e.target.value }))}
//                                 placeholder="50.00"
//                               />
//                             </Form.Group>
//                           </Col>
//                           <Col md={3}>
//                             <Form.Group className="mb-3">
//                               <Form.Label>Extra Fee ($)</Form.Label>
//                               <Form.Control
//                                 type="number"
//                                 step="0.01"
//                                 value={newRange.extra_fee}
//                                 onChange={e => setNewRange(prev => ({ ...prev, extra_fee: e.target.value }))}
//                                 placeholder="0.00"
//                               />
//                             </Form.Group>
//                           </Col>
//                           <Col md={2} className="d-flex align-items-end">
//                             <Button variant="primary" onClick={addDeliveryRange} disabled={saveLoader} className="mb-3">
//                               ➕ Add Range
//                             </Button>
//                           </Col>
//                         </Row>

//                         <small className="text-muted">
//                           * Ranges must be continuous with no gaps. Next range will start from {getNextRangeStart()}{" "}
//                           miles.
//                         </small>
//                       </div>
//                     </div>
//                   )}
//                 </>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Delete Confirmation Modal */}
//       <Modal show={deleteModal} onHide={() => setDeleteModal(false)} backdrop="static" keyboard={false}>
//         <Modal.Header closeButton>
//           <Modal.Title>Delete Delivery Range</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           Are you sure you want to delete this delivery range? This will also delete all associated city pricing.
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setDeleteModal(false)}>
//             Cancel
//           </Button>
//           <Button variant="danger" disabled={delLoader} onClick={deleteDeliveryRange}>
//             {delLoader ? <Spinner size="sm" /> : "Delete"}
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </Fragment>
//   )
// }

// export default FurnitureDeliverySetup

// 2nd version

// import { Fragment, useEffect, useState } from "react"
// import { Modal, Spinner, Button, Form, Row, Col, Alert } from "react-bootstrap"
// import axios from "axios"
// import { useUserState } from "../../../Contexts/UserContext"
// import LocationSelectorMap from "@common/LocationSelectorMap"
// import GoogleMapsSelector from "@common/GoogleMapsSelector"

// const tabs = [
//   { id: "profile", name: "Profile Setup" },
//   { id: "delivery", name: "Delivery Fee" },
// ]

// // Configuration - set your Google Maps API key here
// const Maps_API_KEY = import.meta.env.VITE_Maps_API_KEY || ""
// const USE_Maps = !!Maps_API_KEY // Use Google Maps if API key is available

// const FurnitureDeliverySetup = () => {
//   const { user } = useUserState()
//   const [activeTab, setActiveTab] = useState("profile")
//   const [isLoader, setIsLoader] = useState(false)
//   const [saveLoader, setSaveLoader] = useState(false)

//   // Company Profile State
//   const [companyProfile, setCompanyProfile] = useState({
//     id: null,
//     company_name: "",
//     description: "",
//     address: "",
//     city: "",
//     state: "",
//     postal_code: "",
//     country: "",
//     latitude: "",
//     longitude: "",
//   })

//   // Delivery Ranges State
//   const [deliveryRanges, setDeliveryRanges] = useState([])
//   const [newRange, setNewRange] = useState({
//     min_range: "",
//     max_range: "",
//     price: "",
//     extra_fee: "",
//   })

//   // City Pricing State
//   const [cityPricing, setCityPricing] = useState({})
//   const [showCityForm, setShowCityForm] = useState({})
//   const [newCityPrice, setNewCityPrice] = useState({
//     state: "",
//     county: "",
//     city: "",
//     zip_code: "",
//     extra_price: "",
//   })

//   // Error and Success States
//   const [error, setError] = useState("")
//   const [success, setSuccess] = useState("")
//   const [deleteModal, setDeleteModal] = useState(false)
//   const [deleteRangeId, setDeleteRangeId] = useState("")
//   const [delLoader, setDelLoader] = useState(false)

//   // Map visibility state
//   const [showMap, setShowMap] = useState(false)

//   // Add these new state variables after the existing ones
//   const [editingRange, setEditingRange] = useState(null)
//   const [editingRangeData, setEditingRangeData] = useState({
//     min_range: "",
//     max_range: "",
//     price: "",
//     extra_fee: "",
//   })
//   const [editingCity, setEditingCity] = useState(null)

//   // Handle location change from map component
//   const handleLocationChange = (locationData) => {
//     setCompanyProfile((prev) => ({
//       ...prev,
//       latitude: locationData.latitude,
//       longitude: locationData.longitude,
//       address: locationData.address || prev.address,
//       city: locationData.city || prev.city,
//       state: locationData.state || prev.state,
//       country: locationData.country || prev.country,
//       postal_code: locationData.zipCode || prev.postal_code,
//     }))
//   }

//   // Handle address change from map component
//   const handleAddressChange = (address) => {
//     setCompanyProfile((prev) => ({
//       ...prev,
//       address: address,
//     }))
//   }

//   // Fetch company profile
//   const getCompanyProfile = async () => {
//     const headersFormData = {
//       "Content-Type": "application/json",
//       Authorization: user?.token,
//     }

//     if (user?.token) {
//       setIsLoader(true)
//       try {
//         // First try to get existing company info
//         const res = await axios.get(`${import.meta.env.VITE_APP_BASE_URL}/api/company/get`, {
//           headers: headersFormData,
//         })
//         if (res.data?.data) {
//           setCompanyProfile(res.data.data)
//         }
//         setIsLoader(false)
//       } catch (err) {
//         console.log("No existing company profile found")
//         setIsLoader(false)
//       }
//     }
//   }

//   // Fetch delivery ranges
//   const getDeliveryRanges = async () => {
//     const headersFormData = {
//       "Content-Type": "application/json",
//       Authorization: user?.token,
//     }

//     if (user?.token && companyProfile.id) {
//       setIsLoader(true)
//       try {
//         const res = await axios.get(
//           `${import.meta.env.VITE_APP_BASE_URL}/api/company/furniture/ranges/${companyProfile.id}`,
//           { headers: headersFormData },
//         )
//         if (res.data?.data) {
//           setDeliveryRanges(res.data.data)
//           // Extract city pricing from ranges
//           const cityPricingData = {}
//           res.data.data.forEach((range) => {
//             if (range.FurnitureDeliveryCityPrices) {
//               cityPricingData[range.id] = range.FurnitureDeliveryCityPrices
//             }
//           })
//           setCityPricing(cityPricingData)
//         }
//         setIsLoader(false)
//       } catch (err) {
//         console.log(err)
//         setIsLoader(false)
//       }
//     }
//   }

//   // Save company profile
//   const saveCompanyProfile = async () => {
//     const headersFormData = {
//       "Content-Type": "application/json",
//       Authorization: user?.token,
//     }

//     setSaveLoader(true)
//     setError("")
//     setSuccess("")

//     try {
//       let res
//       if (companyProfile.id) {
//         // Update existing company
//         res = await axios.put(
//           `${import.meta.env.VITE_APP_BASE_URL}/api/company/update/${companyProfile.id}`,
//           companyProfile,
//           { headers: headersFormData },
//         )
//       } else {
//         // Create new company
//         res = await axios.post(`${import.meta.env.VITE_APP_BASE_URL}/api/company/create`, companyProfile, {
//           headers: headersFormData,
//         })
//       }

//       if (res.data?.success) {
//         if (res.data.data) {
//           setCompanyProfile(res.data.data)
//         }
//         setSuccess("Company profile saved successfully!")
//         setTimeout(() => setSuccess(""), 3000)
//       }
//       setSaveLoader(false)
//     } catch (err) {
//       setError(err.response?.data?.message || "Failed to save profile")
//       setSaveLoader(false)
//     }
//   }

//   // Validate range continuity
//   const validateRangeContinuity = (newFromMiles, newToMiles, excludeRangeId = null) => {
//     const sortedRanges = [...deliveryRanges]
//       .filter((range) => range.id !== excludeRangeId)
//       .sort((a, b) => a.min_range - b.min_range)

//     // Check if new range creates gaps or overlaps
//     for (let i = 0; i < sortedRanges.length; i++) {
//       const range = sortedRanges[i]

//       // Check for overlaps
//       if (
//         (newFromMiles >= range.min_range && newFromMiles < range.max_range) ||
//         (newToMiles > range.min_range && newToMiles <= range.max_range) ||
//         (newFromMiles <= range.min_range && newToMiles >= range.max_range)
//       ) {
//         return "Range overlaps with existing range"
//       }
//     }

//     // Check for gaps
//     if (sortedRanges.length > 0) {
//       const lastRange = sortedRanges[sortedRanges.length - 1]
//       if (newFromMiles !== lastRange.max_range && newFromMiles !== 0) {
//         return "Range must be continuous. Start from where the last range ended."
//       }
//     }

//     return null
//   }

//   // Add delivery range
//   const addDeliveryRange = async () => {
//     const { min_range, max_range, price, extra_fee } = newRange

//     if (!min_range || !max_range || !price) {
//       setError("Please fill all required fields")
//       return
//     }

//     if (Number.parseInt(min_range) >= Number.parseInt(max_range)) {
//       setError("To miles must be greater than from miles")
//       return
//     }

//     const validationError = validateRangeContinuity(Number.parseInt(min_range), Number.parseInt(max_range))
//     if (validationError) {
//       setError(validationError)
//       return
//     }

//     const headersFormData = {
//       "Content-Type": "application/json",
//       Authorization: user?.token,
//     }

//     setSaveLoader(true)
//     setError("")

//     try {
//       const res = await axios.post(
//         `${import.meta.env.VITE_APP_BASE_URL}/api/company/furniture/range/update`,
//         {
//           company_id: Number(companyProfile.id),
//           min_range: Number.parseInt(min_range),
//           max_range: Number.parseInt(max_range),
//           price: Number.parseFloat(price),
//           extra_fee: Number.parseFloat(extra_fee) || 0,
//         },
//         { headers: headersFormData },
//       )

//       if (res.data?.success) {
//         setSuccess("Delivery range added successfully!")
//         setNewRange({ min_range: "", max_range: "", price: "", extra_fee: "" })
//         getDeliveryRanges()
//         setTimeout(() => setSuccess(""), 3000)
//       }
//       setSaveLoader(false)
//     } catch (err) {
//       setError(err.response?.data?.message || "Failed to add delivery range")
//       setSaveLoader(false)
//     }
//   }

//   // Delete delivery range
//   const deleteDeliveryRange = async () => {
//     const headersFormData = {
//       "Content-Type": "application/json",
//       Authorization: user?.token,
//     }

//     setDelLoader(true)
//     try {
//       const res = await axios.delete(
//         `${import.meta.env.VITE_APP_BASE_URL}/api/company/furniture/range/delete/${deleteRangeId}`,
//         { headers: headersFormData },
//       )

//       if (res.data?.success) {
//         getDeliveryRanges()
//         setDeleteModal(false)
//         setSuccess("Delivery range deleted successfully!")
//         setTimeout(() => setSuccess(""), 3000)
//       }
//       setDelLoader(false)
//     } catch (err) {
//       setError(err.response?.data?.message || "Failed to delete range")
//       setDelLoader(false)
//     }
//   }

//   // Add city pricing
//   const addCityPricing = async (rangeId) => {
//     const { state, county, city, zip_code, extra_price } = newCityPrice

//     if (!city || !extra_price) {
//       setError("Please fill city name and extra price fields")
//       return
//     }

//     const headersFormData = {
//       "Content-Type": "application/json",
//       Authorization: user?.token,
//     }

//     setSaveLoader(true)
//     setError("")

//     try {
//       const res = await axios.post(
//         `${import.meta.env.VITE_APP_BASE_URL}/api/company/furniture/city-price/update`,
//         {
//           furniture_range_id: rangeId,
//           state: state || "",
//           county: county || "",
//           city,
//           zip_code: zip_code || "",
//           extra_price: Number.parseFloat(extra_price),
//         },
//         { headers: headersFormData },
//       )

//       if (res.data?.success) {
//         setSuccess("City pricing added successfully!")
//         setNewCityPrice({ state: "", county: "", city: "", zip_code: "", extra_price: "" })
//         setShowCityForm((prev) => ({ ...prev, [rangeId]: false }))
//         getDeliveryRanges()
//         setTimeout(() => setSuccess(""), 3000)
//       }
//       setSaveLoader(false)
//     } catch (err) {
//       setError(err.response?.data?.message || "Failed to add city pricing")
//       setSaveLoader(false)
//     }
//   }

//   // Update delivery range
//   const updateDeliveryRange = async () => {
//     const { min_range, max_range, price, extra_fee } = editingRangeData

//     if (!min_range || !max_range || !price) {
//       setError("Please fill all required fields")
//       return
//     }

//     if (Number.parseInt(min_range) >= Number.parseInt(max_range)) {
//       setError("To miles must be greater than from miles")
//       return
//     }

//     const validationError = validateRangeContinuity(
//       Number.parseInt(min_range),
//       Number.parseInt(max_range),
//       editingRange,
//     )
//     if (validationError) {
//       setError(validationError)
//       return
//     }

//     const headersFormData = {
//       "Content-Type": "application/json",
//       Authorization: user?.token,
//     }

//     setSaveLoader(true)
//     setError("")

//     try {
//       const res = await axios.post(
//         `${import.meta.env.VITE_APP_BASE_URL}/api/company/furniture/range/update/${editingRange}`,
//         {
//           company_id: companyProfile.id,
//           min_range: Number.parseInt(min_range),
//           max_range: Number.parseInt(max_range),
//           price: Number.parseFloat(price),
//           extra_fee: Number.parseFloat(extra_fee) || 0,
//         },
//         { headers: headersFormData },
//       )

//       if (res.data?.success) {
//         setSuccess("Delivery range updated successfully!")
//         setEditingRange(null)
//         setEditingRangeData({ min_range: "", max_range: "", price: "", extra_fee: "" })
//         getDeliveryRanges()
//         setTimeout(() => setSuccess(""), 3000)
//       }
//       setSaveLoader(false)
//     } catch (err) {
//       setError(err.response?.data?.message || "Failed to update delivery range")
//       setSaveLoader(false)
//     }
//   }

//   // Update city pricing
//   const updateCityPricing = async (rangeId) => {
//     const { state, county, city, zip_code, extra_price } = editingCity

//     if (!city || !extra_price) {
//       setError("Please fill city name and extra price fields")
//       return
//     }

//     const headersFormData = {
//       "Content-Type": "application/json",
//       Authorization: user?.token,
//     }

//     setSaveLoader(true)
//     setError("")

//     try {
//       const res = await axios.post(
//         `${import.meta.env.VITE_APP_BASE_URL}/api/company/furniture/city-price/update/${editingCity.cityId}`,
//         {
//           furniture_range_id: rangeId,
//           state: state || "",
//           county: county || "",
//           city,
//           zip_code: zip_code || "",
//           extra_price: Number.parseFloat(extra_price),
//         },
//         { headers: headersFormData },
//       )

//       if (res.data?.success) {
//         setSuccess("City pricing updated successfully!")
//         setEditingCity(null)
//         setShowCityForm((prev) => ({ ...prev, [rangeId]: false }))
//         getDeliveryRanges()
//         setTimeout(() => setSuccess(""), 3000)
//       }
//       setSaveLoader(false)
//     } catch (err) {
//       setError(err.response?.data?.message || "Failed to update city pricing")
//       setSaveLoader(false)
//     }
//   }

//   // Delete city pricing
//   const deleteCityPricing = async (cityId, rangeId) => {
//     const headersFormData = {
//       "Content-Type": "application/json",
//       Authorization: user?.token,
//     }

//     try {
//       const res = await axios.delete(
//         `${import.meta.env.VITE_APP_BASE_URL}/api/company/furniture/city-price/delete/${cityId}`,
//         { headers: headersFormData },
//       )

//       if (res.data?.success) {
//         setSuccess("City pricing deleted successfully!")
//         getDeliveryRanges()
//         setTimeout(() => setSuccess(""), 3000)
//       }
//     } catch (err) {
//       setError(err.response?.data?.message || "Failed to delete city pricing")
//     }
//   }

//   // Get next range start value
//   const getNextRangeStart = () => {
//     if (deliveryRanges.length === 0) return 0
//     const sortedRanges = [...deliveryRanges].sort((a, b) => a.min_range - b.min_range)
//     return sortedRanges[sortedRanges.length - 1].max_range
//   }

//   // Handle editing range
//   useEffect(() => {
//     if (editingRange) {
//       const rangeToEdit = deliveryRanges.find((range) => range.id === editingRange)
//       if (rangeToEdit) {
//         setEditingRangeData({
//           min_range: rangeToEdit.min_range.toString(),
//           max_range: rangeToEdit.max_range.toString(),
//           price: rangeToEdit.price.toString(),
//           extra_fee: rangeToEdit.extra_fee.toString(),
//         })
//       }
//     }
//   }, [editingRange, deliveryRanges])

//   useEffect(() => {
//     if (activeTab === "profile") {
//       getCompanyProfile()
//     } else if (activeTab === "delivery") {
//       getDeliveryRanges()
//     }
//   }, [activeTab, user?.token])

//   useEffect(() => {
//     const nextStart = getNextRangeStart()
//     setNewRange((prev) => ({ ...prev, min_range: nextStart.toString() }))
//   }, [deliveryRanges])

//   return (
//     <Fragment>
//       <div className="main-box">
//         <div className="content-header">
//           <h3>Furniture Delivery Setup</h3>
//         </div>

//         {error && <Alert variant="danger">{error}</Alert>}
//         {success && <Alert variant="success">{success}</Alert>}

//         <div className="myfurnit_store_main">
//           <ul className="nav nav-tabs" id="myTab" role="tablist">
//             {tabs.map((tab) => (
//               <li className="nav-item" role="presentation" key={tab.id}>
//                 <button
//                   className={`nav-link ${activeTab === tab.id ? "active" : ""}`}
//                   type="button"
//                   onClick={() => setActiveTab(tab.id)}
//                 >
//                   {tab.name}
//                 </button>
//               </li>
//             ))}
//           </ul>

//           <div className="tab-content" id="myTabContent">
//             <div className="tab-pane fade show active" role="tabpanel">
//               {isLoader ? (
//                 <div className="eye-loader-frame m-5 p-5">
//                   <div className="eye-loader-spinner"></div>
//                 </div>
//               ) : (
//                 <>
//                   {activeTab === "profile" && (
//                     <div className="company-profile-form p-4">
//                       <h4>Company Profile Information</h4>
//                       <Form>
//                         <Row>
//                           <Col md={6}>
//                             <Form.Group className="mb-3">
//                               <Form.Label>Company Name *</Form.Label>
//                               <Form.Control
//                                 type="text"
//                                 value={companyProfile.company_name}
//                                 onChange={(e) =>
//                                   setCompanyProfile((prev) => ({ ...prev, company_name: e.target.value }))
//                                 }
//                                 placeholder="Enter company name"
//                               />
//                             </Form.Group>
//                           </Col>
//                           <Col md={6}>
//                             <Form.Group className="mb-3">
//                               <Form.Label>City *</Form.Label>
//                               <Form.Control
//                                 type="text"
//                                 value={companyProfile.city}
//                                 onChange={(e) => setCompanyProfile((prev) => ({ ...prev, city: e.target.value }))}
//                                 placeholder="Enter city"
//                               />
//                             </Form.Group>
//                           </Col>
//                         </Row>
// {/*
//                         <Form.Group className="mb-3">
//                           <Form.Label>Description</Form.Label>
//                           <Form.Control
//                             as="textarea"
//                             rows={3}
//                             value={companyProfile.description}
//                             onChange={(e) => setCompanyProfile((prev) => ({ ...prev, description: e.target.value }))}
//                             placeholder="Enter company description"
//                           />
//                         </Form.Group> */}

//                         <Form.Group className="mb-3">
//                           <Form.Label>Address</Form.Label>
//                           <Form.Control
//                             type="text"
//                             value={companyProfile.address}
//                             onChange={(e) => setCompanyProfile((prev) => ({ ...prev, address: e.target.value }))}
//                             placeholder="Enter full address"
//                           />
//                         </Form.Group>

//                         <Row>
//                           <Col md={4}>
//                             <Form.Group className="mb-3">
//                               <Form.Label>State</Form.Label>
//                               <Form.Control
//                                 type="text"
//                                 value={companyProfile.state}
//                                 onChange={(e) => setCompanyProfile((prev) => ({ ...prev, state: e.target.value }))}
//                                 placeholder="Enter state"
//                               />
//                             </Form.Group>
//                           </Col>
//                           <Col md={4}>
//                             <Form.Group className="mb-3">
//                               <Form.Label>Postal Code</Form.Label>
//                               <Form.Control
//                                 type="text"
//                                 value={companyProfile.postal_code}
//                                 onChange={(e) =>
//                                   setCompanyProfile((prev) => ({ ...prev, postal_code: e.target.value }))
//                                 }
//                                 placeholder="Enter postal code"
//                               />
//                             </Form.Group>
//                           </Col>
//                           <Col md={4}>
//                             <Form.Group className="mb-3">
//                               <Form.Label>Country</Form.Label>
//                               <Form.Control
//                                 type="text"
//                                 value={companyProfile.country}
//                                 onChange={(e) => setCompanyProfile((prev) => ({ ...prev, country: e.target.value }))}
//                                 placeholder="Enter country"
//                               />
//                             </Form.Group>
//                           </Col>
//                         </Row>

//                         {/* Enhanced Location Selection Section */}
//                         <div className="location-section mb-4">
//                           <div className="d-flex justify-content-between align-items-center mb-3">
//                             <h5>Business Location</h5>
//                             <div>
//                               <Button variant="outline-primary" size="sm" onClick={() => setShowMap(!showMap)}>
//                                 {showMap ? "Hide Map" : "📍 Select on Map"}
//                               </Button>
//                             </div>
//                           </div>

//                           {showMap && (
//                             <>
//                               {USE_Maps ? (
//                                 <GoogleMapsSelector
//                                   initialLatitude={companyProfile.latitude}
//                                   initialLongitude={companyProfile.longitude}
//                                   initialAddress={companyProfile.address}
//                                   onLocationChange={handleLocationChange}
//                                   onAddressChange={handleAddressChange}
//                                   googleMapsApiKey={Maps_API_KEY}
//                                   mapHeight="400px"
//                                   className="mb-3"
//                                 />
//                               ) : (
//                                 <LocationSelectorMap
//                                   initialLatitude={companyProfile.latitude}
//                                   initialLongitude={companyProfile.longitude}
//                                   initialAddress={companyProfile.address}
//                                   onLocationChange={handleLocationChange}
//                                   onAddressChange={handleAddressChange}
//                                   showDeliveryZones={deliveryRanges.length > 0}
//                                   deliveryZones={deliveryRanges.map((range) => ({
//                                     min_range: range.min_range,
//                                     max_range: range.max_range,
//                                   }))}
//                                   showAddressSearch={true}
//                                   showCurrentLocation={true}
//                                   showCoordinateInputs={true}
//                                   mapHeight="400px"
//                                   className="mb-3"
//                                 />
//                               )}
//                             </>
//                           )}

//                           {!showMap && (
//                             <Row>
//                               <Col md={6}>
//                                 <Form.Group className="mb-3">
//                                   <Form.Label>Latitude</Form.Label>
//                                   <Form.Control
//                                     type="number"
//                                     step="0.00000001"
//                                     value={companyProfile.latitude}
//                                     onChange={(e) =>
//                                       setCompanyProfile((prev) => ({ ...prev, latitude: e.target.value }))
//                                     }
//                                     placeholder="Enter latitude or select on map"
//                                   />
//                                 </Form.Group>
//                               </Col>
//                               <Col md={6}>
//                                 <Form.Group className="mb-3">
//                                   <Form.Label>Longitude</Form.Label>
//                                   <Form.Control
//                                     type="number"
//                                     step="0.00000001"
//                                     value={companyProfile.longitude}
//                                     onChange={(e) =>
//                                       setCompanyProfile((prev) => ({ ...prev, longitude: e.target.value }))
//                                     }
//                                     placeholder="Enter longitude or select on map"
//                                   />
//                                 </Form.Group>
//                               </Col>
//                             </Row>
//                           )}
//                         </div>

//                         <Button variant="primary" onClick={saveCompanyProfile} disabled={saveLoader}>
//                           {saveLoader ? <Spinner size="sm" /> : "Save Profile"}
//                         </Button>
//                       </Form>
//                     </div>
//                   )}

//                   {activeTab === "delivery" && (
//                     <div className="delivery-setup p-4">
//                       <h4>Delivery Fee Setup</h4>

//                       {!companyProfile.id && (
//                         <Alert variant="warning" className="mb-4">
//                           Please save your company profile first before setting up delivery ranges.
//                         </Alert>
//                       )}

//                       {companyProfile.id && deliveryRanges.length === 0 && (
//                         <div className="no-delivery-setup mb-4">
//                           <Alert variant="info">No delivery fees setup yet. Add your first delivery range below.</Alert>
//                         </div>
//                       )}

//                       {companyProfile.id && deliveryRanges.length > 0 && (
//                         <div className="existing-ranges mb-4">
//                           <h5>Current Delivery Ranges</h5>
//                           {deliveryRanges
//                             .sort((a, b) => a.min_range - b.min_range)
//                             .map((range, index) => (
//                               <div key={range.id} className="range-item border p-3 mb-3 rounded">
//                                 {editingRange === range.id ? (
//                                   // Edit Mode
//                                   <div className="edit-range-form">
//                                     <div className="d-flex justify-content-between align-items-center mb-3">
//                                       <h6 className="mb-0 text-primary">✏️ Editing Range</h6>
//                                       <Button
//                                         variant="outline-secondary"
//                                         size="sm"
//                                         onClick={() => {
//                                           setEditingRange(null)
//                                           setEditingRangeData({
//                                             min_range: "",
//                                             max_range: "",
//                                             price: "",
//                                             extra_fee: "",
//                                           })
//                                         }}
//                                       >
//                                         Cancel
//                                       </Button>
//                                     </div>

//                                     <Row>
//                                       <Col md={2}>
//                                         <Form.Group className="mb-3">
//                                           <Form.Label>From Miles</Form.Label>
//                                           <Form.Control
//                                             type="number"
//                                             value={editingRangeData.min_range}
//                                             onChange={(e) =>
//                                               setEditingRangeData((prev) => ({ ...prev, min_range: e.target.value }))
//                                             }
//                                             placeholder="0"
//                                           />
//                                         </Form.Group>
//                                       </Col>
//                                       <Col md={2}>
//                                         <Form.Group className="mb-3">
//                                           <Form.Label>To Miles</Form.Label>
//                                           <Form.Control
//                                             type="number"
//                                             value={editingRangeData.max_range}
//                                             onChange={(e) =>
//                                               setEditingRangeData((prev) => ({ ...prev, max_range: e.target.value }))
//                                             }
//                                             placeholder="40"
//                                           />
//                                         </Form.Group>
//                                       </Col>
//                                       <Col md={3}>
//                                         <Form.Group className="mb-3">
//                                           <Form.Label>Base Price ($)</Form.Label>
//                                           <Form.Control
//                                             type="number"
//                                             step="0.01"
//                                             value={editingRangeData.price}
//                                             onChange={(e) =>
//                                               setEditingRangeData((prev) => ({ ...prev, price: e.target.value }))
//                                             }
//                                             placeholder="50.00"
//                                           />
//                                         </Form.Group>
//                                       </Col>
//                                       <Col md={3}>
//                                         <Form.Group className="mb-3">
//                                           <Form.Label>Extra Fee ($)</Form.Label>
//                                           <Form.Control
//                                             type="number"
//                                             step="0.01"
//                                             value={editingRangeData.extra_fee}
//                                             onChange={(e) =>
//                                               setEditingRangeData((prev) => ({ ...prev, extra_fee: e.target.value }))
//                                             }
//                                             placeholder="0.00"
//                                           />
//                                         </Form.Group>
//                                       </Col>
//                                       <Col md={2} className="d-flex align-items-end">
//                                         <Button
//                                           variant="success"
//                                           onClick={updateDeliveryRange}
//                                           disabled={saveLoader}
//                                           className="mb-3 w-100"
//                                         >
//                                           {saveLoader ? <Spinner size="sm" /> : "💾 Save"}
//                                         </Button>
//                                       </Col>
//                                     </Row>
//                                   </div>
//                                 ) : (
//                                   // View Mode
//                                   <>
//                                     <div className="d-flex justify-content-between align-items-center mb-2">
//                                       <div>
//                                         <strong>
//                                           {range.min_range} - {range.max_range} miles
//                                         </strong>
//                                         <span className="ms-3">Base Price: ${range.price}</span>
//                                         {range.extra_fee > 0 && (
//                                           <span className="ms-3">Extra Fee: ${range.extra_fee}</span>
//                                         )}
//                                       </div>
//                                       <div>
//                                         <Button
//                                           variant="outline-primary"
//                                           size="sm"
//                                           className="me-2"
//                                           onClick={() => setEditingRange(range.id)}
//                                           disabled={
//                                             editingRange !== null ||
//                                             newRange.min_range !== "" ||
//                                             newRange.max_range !== "" ||
//                                             newRange.price !== "" ||
//                                             newRange.extra_fee !== ""
//                                           }
//                                         >
//                                           ✏️ Edit
//                                         </Button>
//                                         <Button
//                                           variant="outline-danger"
//                                           size="sm"
//                                           onClick={() => {
//                                             setDeleteRangeId(range.id)
//                                             setDeleteModal(true)
//                                           }}
//                                           disabled={
//                                             editingRange !== null ||
//                                             newRange.min_range !== "" ||
//                                             newRange.max_range !== "" ||
//                                             newRange.price !== "" ||
//                                             newRange.extra_fee !== ""
//                                           }
//                                         >
//                                           🗑️ Delete
//                                         </Button>
//                                       </div>
//                                     </div>

//                                     {/* City Pricing Section - Only show if not editing any range */}
//                                     {editingRange === null && (
//                                       <div className="city-pricing mt-3">
//                                         <div className="d-flex justify-content-between align-items-center mb-2">
//                                           <h6 className="mb-0">Serviceable Cities</h6>
//                                           <Button
//                                             variant="outline-success"
//                                             size="sm"
//                                             onClick={() =>
//                                               setShowCityForm((prev) => ({
//                                                 ...prev,
//                                                 [range.id]: !prev[range.id],
//                                               }))
//                                             }
//                                             disabled={
//                                               newRange.min_range !== "" ||
//                                               newRange.max_range !== "" ||
//                                               newRange.price !== "" ||
//                                               newRange.extra_fee !== ""
//                                             }
//                                           >
//                                             ➕ Add Serviceable Area for Extra Price
//                                           </Button>
//                                         </div>

//                                         {cityPricing[range.id] && cityPricing[range.id].length > 0 && (
//                                           <div className="city-list">
//                                             <div className="row fw-bold border-bottom pb-2 mb-2">
//                                               <div className="col-3">City Name</div>
//                                               <div className="col-2">State</div>
//                                               <div className="col-2">County</div>
//                                               <div className="col-2">Extra Cost</div>
//                                               <div className="col-2">Total Cost</div>
//                                               <div className="col-1">Actions</div>
//                                             </div>
//                                             {cityPricing[range.id].map((city) => (
//                                               <div key={city.id} className="row py-2 border-bottom">
//                                                 <div className="col-3">{city.city}</div>
//                                                 <div className="col-2">{city.state || "-"}</div>
//                                                 <div className="col-2">{city.county || "-"}</div>
//                                                 <div className="col-2">+${city.extra_price}</div>
//                                                 <div className="col-2">
//                                                   $
//                                                   {(
//                                                     Number.parseFloat(range.price) + Number.parseFloat(city.extra_price)
//                                                   ).toFixed(2)}
//                                                 </div>
//                                                 <div className="col-1">
//                                                   <Button
//                                                     variant="outline-primary"
//                                                     size="sm"
//                                                     className="me-1"
//                                                     onClick={() =>
//                                                       setEditingCity({ rangeId: range.id, cityId: city.id, ...city })
//                                                     }
//                                                     disabled={
//                                                       newRange.min_range !== "" ||
//                                                       newRange.max_range !== "" ||
//                                                       newRange.price !== "" ||
//                                                       newRange.extra_fee !== ""
//                                                     }
//                                                   >
//                                                     ✏️
//                                                   </Button>
//                                                   <Button
//                                                     variant="outline-danger"
//                                                     size="sm"
//                                                     onClick={() => deleteCityPricing(city.id, range.id)}
//                                                     disabled={
//                                                       newRange.min_range !== "" ||
//                                                       newRange.max_range !== "" ||
//                                                       newRange.price !== "" ||
//                                                       newRange.extra_fee !== ""
//                                                     }
//                                                   >
//                                                     🗑️
//                                                   </Button>
//                                                 </div>
//                                               </div>
//                                             ))}
//                                           </div>
//                                         )}

//                                         {showCityForm[range.id] && (
//                                           <div className="city-form mt-3 p-3 bg-light rounded">
//                                             <h6>{editingCity?.cityId ? "Edit" : "Add"} City Pricing</h6>
//                                             <Row>
//                                               <Col md={3}>
//                                                 <Form.Group className="mb-2">
//                                                   <Form.Label>City Name *</Form.Label>
//                                                   <Form.Control
//                                                     type="text"
//                                                     placeholder="Enter city name"
//                                                     value={
//                                                       editingCity?.rangeId === range.id
//                                                         ? editingCity.city
//                                                         : newCityPrice.city
//                                                     }
//                                                     onChange={(e) => {
//                                                       if (editingCity?.rangeId === range.id) {
//                                                         setEditingCity((prev) => ({
//                                                           ...prev,
//                                                           city: e.target.value,
//                                                         }))
//                                                       } else {
//                                                         setNewCityPrice((prev) => ({
//                                                           ...prev,
//                                                           city: e.target.value,
//                                                         }))
//                                                       }
//                                                     }}
//                                                   />
//                                                 </Form.Group>
//                                               </Col>
//                                               <Col md={2}>
//                                                 <Form.Group className="mb-2">
//                                                   <Form.Label>State</Form.Label>
//                                                   <Form.Control
//                                                     type="text"
//                                                     placeholder="State"
//                                                     value={
//                                                       editingCity?.rangeId === range.id
//                                                         ? editingCity.state
//                                                         : newCityPrice.state
//                                                     }
//                                                     onChange={(e) => {
//                                                       if (editingCity?.rangeId === range.id) {
//                                                         setEditingCity((prev) => ({
//                                                           ...prev,
//                                                           state: e.target.value,
//                                                         }))
//                                                       } else {
//                                                         setNewCityPrice((prev) => ({
//                                                           ...prev,
//                                                           state: e.target.value,
//                                                         }))
//                                                       }
//                                                     }}
//                                                   />
//                                                 </Form.Group>
//                                               </Col>
//                                               <Col md={2}>
//                                                 <Form.Group className="mb-2">
//                                                   <Form.Label>County</Form.Label>
//                                                   <Form.Control
//                                                     type="text"
//                                                     placeholder="County"
//                                                     value={
//                                                       editingCity?.rangeId === range.id
//                                                         ? editingCity.county
//                                                         : newCityPrice.county
//                                                     }
//                                                     onChange={(e) => {
//                                                       if (editingCity?.rangeId === range.id) {
//                                                         setEditingCity((prev) => ({
//                                                           ...prev,
//                                                           county: e.target.value,
//                                                         }))
//                                                       } else {
//                                                         setNewCityPrice((prev) => ({
//                                                           ...prev,
//                                                           county: e.target.value,
//                                                         }))
//                                                       }
//                                                     }}
//                                                   />
//                                                 </Form.Group>
//                                               </Col>
//                                               <Col md={2}>
//                                                 <Form.Group className="mb-2">
//                                                   <Form.Label>ZIP Code</Form.Label>
//                                                   <Form.Control
//                                                     type="text"
//                                                     placeholder="ZIP"
//                                                     value={
//                                                       editingCity?.rangeId === range.id
//                                                         ? editingCity.zip_code
//                                                         : newCityPrice.zip_code
//                                                     }
//                                                     onChange={(e) => {
//                                                       if (editingCity?.rangeId === range.id) {
//                                                         setEditingCity((prev) => ({
//                                                           ...prev,
//                                                           zip_code: e.target.value,
//                                                         }))
//                                                       } else {
//                                                         setNewCityPrice((prev) => ({
//                                                           ...prev,
//                                                           zip_code: e.target.value,
//                                                         }))
//                                                       }
//                                                     }}
//                                                   />
//                                                 </Form.Group>
//                                               </Col>
//                                               <Col md={2}>
//                                                 <Form.Group className="mb-2">
//                                                   <Form.Label>Extra Cost ($) *</Form.Label>
//                                                   <Form.Control
//                                                     type="number"
//                                                     step="0.01"
//                                                     placeholder="0.00"
//                                                     value={
//                                                       editingCity?.rangeId === range.id
//                                                         ? editingCity.extra_price
//                                                         : newCityPrice.extra_price
//                                                     }
//                                                     onChange={(e) => {
//                                                       if (editingCity?.rangeId === range.id) {
//                                                         setEditingCity((prev) => ({
//                                                           ...prev,
//                                                           extra_price: e.target.value,
//                                                         }))
//                                                       } else {
//                                                         setNewCityPrice((prev) => ({
//                                                           ...prev,
//                                                           extra_price: e.target.value,
//                                                         }))
//                                                       }
//                                                     }}
//                                                   />
//                                                 </Form.Group>
//                                               </Col>
//                                               <Col md={1} className="d-flex align-items-end">
//                                                 <div className="d-flex flex-column w-100">
//                                                   <Button
//                                                     variant="success"
//                                                     size="sm"
//                                                     className="mb-1"
//                                                     onClick={() =>
//                                                       editingCity?.rangeId === range.id
//                                                         ? updateCityPricing(range.id)
//                                                         : addCityPricing(range.id)
//                                                     }
//                                                     disabled={saveLoader}
//                                                   >
//                                                     {editingCity?.rangeId === range.id ? "💾 Update" : "💾 Save"}
//                                                   </Button>
//                                                   <Button
//                                                     variant="outline-secondary"
//                                                     size="sm"
//                                                     onClick={() => {
//                                                       setShowCityForm((prev) => ({ ...prev, [range.id]: false }))
//                                                       setEditingCity(null)
//                                                       setNewCityPrice({
//                                                         state: "",
//                                                         county: "",
//                                                         city: "",
//                                                         zip_code: "",
//                                                         extra_price: "",
//                                                       })
//                                                     }}
//                                                   >
//                                                     Cancel
//                                                   </Button>
//                                                 </div>
//                                               </Col>
//                                             </Row>
//                                           </div>
//                                         )}
//                                       </div>
//                                     )}
//                                   </>
//                                 )}
//                               </div>
//                             ))}
//                         </div>
//                       )}

//                       {/* Add New Range Form - Always at bottom */}
//                       {companyProfile.id && (
//                         <div className="add-range-form border p-4 rounded">
//                           <div className="d-flex justify-content-between align-items-center mb-3">
//                             <h5>Add New Delivery Range</h5>
//                             {(newRange.min_range !== "" ||
//                               newRange.max_range !== "" ||
//                               newRange.price !== "" ||
//                               newRange.extra_fee !== "") && (
//                               <div className="d-flex align-items-center">
//                                 <small className="text-warning me-2">
//                                   ⚠️ Save this range before adding another or editing existing ranges
//                                 </small>
//                                 <Button
//                                   variant="outline-secondary"
//                                   size="sm"
//                                   onClick={() => {
//                                     setNewRange({
//                                       min_range: getNextRangeStart().toString(),
//                                       max_range: "",
//                                       price: "",
//                                       extra_fee: "",
//                                     })
//                                   }}
//                                 >
//                                   Clear Form
//                                 </Button>
//                               </div>
//                             )}
//                           </div>

//                           <Row>
//                             <Col md={2}>
//                               <Form.Group className="mb-3">
//                                 <Form.Label>From Miles</Form.Label>
//                                 <Form.Control
//                                   type="number"
//                                   value={newRange.min_range}
//                                   onChange={(e) => setNewRange((prev) => ({ ...prev, min_range: e.target.value }))}
//                                   placeholder="0"
//                                   readOnly={deliveryRanges.length > 0}
//                                   disabled={editingRange !== null}
//                                 />
//                               </Form.Group>
//                             </Col>
//                             <Col md={2}>
//                               <Form.Group className="mb-3">
//                                 <Form.Label>To Miles</Form.Label>
//                                 <Form.Control
//                                   type="number"
//                                   value={newRange.max_range}
//                                   onChange={(e) => setNewRange((prev) => ({ ...prev, max_range: e.target.value }))}
//                                   placeholder="40"
//                                   disabled={editingRange !== null}
//                                 />
//                               </Form.Group>
//                             </Col>
//                             <Col md={3}>
//                               <Form.Group className="mb-3">
//                                 <Form.Label>Base Price ($)</Form.Label>
//                                 <Form.Control
//                                   type="number"
//                                   step="0.01"
//                                   value={newRange.price}
//                                   onChange={(e) => setNewRange((prev) => ({ ...prev, price: e.target.value }))}
//                                   placeholder="50.00"
//                                   disabled={editingRange !== null}
//                                 />
//                               </Form.Group>
//                             </Col>
//                             <Col md={3}>
//                               <Form.Group className="mb-3">
//                                 <Form.Label>Extra Fee ($)</Form.Label>
//                                 <Form.Control
//                                   type="number"
//                                   step="0.01"
//                                   value={newRange.extra_fee}
//                                   onChange={(e) => setNewRange((prev) => ({ ...prev, extra_fee: e.target.value }))}
//                                   placeholder="0.00"
//                                   disabled={editingRange !== null}
//                                 />
//                               </Form.Group>
//                             </Col>
//                             <Col md={2} className="d-flex align-items-end">
//                               <Button
//                                 variant="primary"
//                                 onClick={addDeliveryRange}
//                                 disabled={
//                                   saveLoader ||
//                                   editingRange !== null ||
//                                   !newRange.min_range ||
//                                   !newRange.max_range ||
//                                   !newRange.price
//                                 }
//                                 className="mb-3 w-100"
//                                 title={
//                                   editingRange !== null
//                                     ? "Save or cancel editing current range first"
//                                     : !newRange.min_range || !newRange.max_range || !newRange.price
//                                       ? "Fill all required fields"
//                                       : ""
//                                 }
//                               >
//                                 {saveLoader ? <Spinner size="sm" /> : "💾 Save Range"}
//                               </Button>
//                             </Col>
//                           </Row>

//                           <div className="d-flex justify-content-between align-items-center">
//                             <small className="text-muted">
//                               * Ranges must be continuous with no gaps. Next range will start from {getNextRangeStart()}{" "}
//                               miles.
//                             </small>
//                             {editingRange !== null && (
//                               <small className="text-warning">
//                                 ⚠️ Complete editing the current range before adding a new one
//                               </small>
//                             )}
//                           </div>
//                         </div>
//                       )}

//                       {/* Disabled state overlay for Add Range button */}
//                       {companyProfile.id &&
//                         (newRange.min_range !== "" ||
//                           newRange.max_range !== "" ||
//                           newRange.price !== "" ||
//                           newRange.extra_fee !== "") && (
//                           <div className="mt-3">
//                             <Alert variant="warning" className="mb-0">
//                               <strong>📝 Unsaved Changes:</strong> Please save the current range before adding another
//                               range or managing serviceable areas for existing ranges.
//                             </Alert>
//                           </div>
//                         )}
//                     </div>
//                   )}
//                 </>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Delete Confirmation Modal */}
//       <Modal show={deleteModal} onHide={() => setDeleteModal(false)} backdrop="static" keyboard={false}>
//         <Modal.Header closeButton>
//           <Modal.Title>Delete Delivery Range</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           Are you sure you want to delete this delivery range? This will also delete all associated city pricing.
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setDeleteModal(false)}>
//             Cancel
//           </Button>
//           <Button variant="danger" disabled={delLoader} onClick={deleteDeliveryRange}>
//             {delLoader ? <Spinner size="sm" /> : "Delete"}
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </Fragment>
//   )
// }

// export default FurnitureDeliverySetup

// 3rd version

// "use client"

// import { Fragment, useEffect, useState } from "react"
// import { Modal, Spinner, Button, Form, Row, Col, Alert, Collapse } from "react-bootstrap"
// import axios from "axios"
// import { useUserState } from "../../../Contexts/UserContext"
// import LocationSelectorMap from "@common/LocationSelectorMap"
// import GoogleMapsSelector from "@common/GoogleMapsSelector"

// const tabs = [
//   { id: "profile", name: "Profile Setup" },
//   { id: "delivery", name: "Delivery Fee" },
// ]

// const initialAddNewCityTaxData ={
//   state: "",
//   county: "",
//   city: "",
//   zip_code: "",
//   extra_price: "",
// }

// // Configuration - set your Google Maps API key here
// const Maps_API_KEY = import.meta.env.VITE_Maps_API_KEY || ""
// const USE_Maps = !!Maps_API_KEY // Use Google Maps if API key is available

// const FurnitureDeliverySetup = () => {
//   const { user } = useUserState()
//   const [activeTab, setActiveTab] = useState("profile")
//   const [isLoader, setIsLoader] = useState(false)
//   const [saveLoader, setSaveLoader] = useState(false)

//   // Company Profile State
//   const [companyProfile, setCompanyProfile] = useState({
//     id: null,
//     company_name: "",
//     description: "",
//     address: "",
//     city: "",
//     state: "",
//     postal_code: "",
//     country: "",
//     latitude: "",
//     longitude: "",
//   })

//   // Delivery Ranges State
//   const [deliveryRanges, setDeliveryRanges] = useState([])
//   const [newRange, setNewRange] = useState({
//     min_range: "",
//     max_range: "",
//     price: "",
//     extra_fee: "",
//   })

//   // City Pricing State - Now managed per range
//   const [cityPricing, setCityPricing] = useState({})
//   const [showCityForm, setShowCityForm] = useState({})
//   const [newCityPrices, setNewCityPrices] = useState({}) // Changed to handle multiple ranges

//   // Error and Success States
//   const [error, setError] = useState("")
//   const [success, setSuccess] = useState("")
//   const [deleteModal, setDeleteModal] = useState(false)
//   const [deleteRangeId, setDeleteRangeId] = useState("")
//   const [delLoader, setDelLoader] = useState(false)

//   // Map visibility state
//   const [showMap, setShowMap] = useState(false)

//   // Enhanced state variables for in-place editing
//   const [showAddForm, setShowAddForm] = useState(false)
//   const [editingRange, setEditingRange] = useState(null)
//   const [editingRangeData, setEditingRangeData] = useState({})
//   const [editingCity, setEditingCity] = useState(null)
//   const [editingCityData, setEditingCityData] = useState({})
//   const [collapsedRanges, setCollapsedRanges] = useState({})

//   // Delete city modal state
//   const [deleteCityModal, setDeleteCityModal] = useState(false)
//   const [deleteCityId, setDeleteCityId] = useState("")
//   const [deleteCityRangeId, setDeleteCityRangeId] = useState("")
//   const [addNewCityTax, setAddNewCityTax] = useState({

//   })

//   // Handle location change from map component
//   const handleLocationChange = (locationData) => {
//     setCompanyProfile((prev) => ({
//       ...prev,
//       latitude: locationData.latitude,
//       longitude: locationData.longitude,
//       address: locationData.address || prev.address,
//       city: locationData.city || prev.city,
//       state: locationData.state || prev.state,
//       country: locationData.country || prev.country,
//       postal_code: locationData.zipCode || prev.postal_code,
//     }))
//   }

//   // Handle address change from map component
//   const handleAddressChange = (address) => {
//     setCompanyProfile((prev) => ({
//       ...prev,
//       address: address,
//     }))
//   }

//   // Fetch company profile
//   const getCompanyProfile = async () => {
//     const headersFormData = {
//       "Content-Type": "application/json",
//       Authorization: user?.token,
//     }

//     if (user?.token) {
//       setIsLoader(true)
//       try {
//         const res = await axios.get(`${import.meta.env.VITE_APP_BASE_URL}/api/company/get`, {
//           headers: headersFormData,
//         })
//         if (res.data?.data) {
//           setCompanyProfile(res.data.data)
//         }
//         setIsLoader(false)
//       } catch (err) {
//         console.log("No existing company profile found")
//         setIsLoader(false)
//       }
//     }
//   }

//   // Fetch delivery ranges
//   const getDeliveryRanges = async () => {
//     const headersFormData = {
//       "Content-Type": "application/json",
//       Authorization: user?.token,
//     }

//     if (user?.token && companyProfile.id) {
//       setIsLoader(true)
//       try {
//         const res = await axios.get(
//           `${import.meta.env.VITE_APP_BASE_URL}/api/company/furniture/ranges/${companyProfile.id}`,
//           { headers: headersFormData },
//         )
//         if (res.data?.data) {
//           setDeliveryRanges(res.data.data)
//           // Extract city pricing from ranges
//           const cityPricingData = {}
//           const newCityPricesData = {}
//           res.data.data.forEach((range) => {
//             if (range.FurnitureDeliveryCityPrices) {
//               cityPricingData[range.id] = range.FurnitureDeliveryCityPrices
//             }
//             // Initialize empty form data for each range
//             newCityPricesData[range.id] = {
//               state: "",
//               county: "",
//               city: "",
//               zip_code: "",
//               extra_price: "",
//             }
//           })
//           setCityPricing(cityPricingData)
//           setNewCityPrices(newCityPricesData)
//         }
//         setIsLoader(false)
//       } catch (err) {
//         console.log(err)
//         setIsLoader(false)
//       }
//     }
//   }

//   // Save company profile
//   const saveCompanyProfile = async () => {
//     const headersFormData = {
//       "Content-Type": "application/json",
//       Authorization: user?.token,
//     }

//     setSaveLoader(true)
//     setError("")
//     setSuccess("")

//     try {
//       let res
//       if (companyProfile.id) {
//         res = await axios.put(
//           `${import.meta.env.VITE_APP_BASE_URL}/api/company/update/${companyProfile.id}`,
//           companyProfile,
//           { headers: headersFormData },
//         )
//       } else {
//         res = await axios.post(`${import.meta.env.VITE_APP_BASE_URL}/api/company/create`, companyProfile, {
//           headers: headersFormData,
//         })
//       }

//       if (res.data?.success) {
//         if (res.data.data) {
//           setCompanyProfile(res.data.data)
//         }
//         setSuccess("Company profile saved successfully!")
//         setTimeout(() => setSuccess(""), 3000)
//       }
//       setSaveLoader(false)
//     } catch (err) {
//       setError(err.response?.data?.message || "Failed to save profile")
//       setSaveLoader(false)
//     }
//   }

//   // Validate range continuity
//   const validateRangeContinuity = (newFromMiles, newToMiles, excludeRangeId = null) => {
//     const sortedRanges = [...deliveryRanges]
//       .filter((range) => range.id !== excludeRangeId)
//       .sort((a, b) => a.min_range - b.min_range)

//     for (let i = 0; i < sortedRanges.length; i++) {
//       const range = sortedRanges[i]

//       if (
//         (newFromMiles >= range.min_range && newFromMiles < range.max_range) ||
//         (newToMiles > range.min_range && newToMiles <= range.max_range) ||
//         (newFromMiles <= range.min_range && newToMiles >= range.max_range)
//       ) {
//         return "Range overlaps with existing range"
//       }
//     }

//     if (sortedRanges.length > 0) {
//       const lastRange = sortedRanges[sortedRanges.length - 1]
//       if (newFromMiles !== lastRange.max_range && newFromMiles !== 0) {
//         return "Range must be continuous. Start from where the last range ended."
//       }
//     }

//     return null
//   }

//   // Add delivery range
//   const addDeliveryRange = async () => {
//     const { min_range, max_range, price, extra_fee } = newRange

//     if (!min_range || !max_range || !price) {
//       setError("Please fill all required fields")
//       return
//     }

//     if (Number.parseInt(min_range) >= Number.parseInt(max_range)) {
//       setError("To miles must be greater than from miles")
//       return
//     }

//     const validationError = validateRangeContinuity(Number.parseInt(min_range), Number.parseInt(max_range))
//     if (validationError) {
//       setError(validationError)
//       return
//     }

//     const headersFormData = {
//       "Content-Type": "application/json",
//       Authorization: user?.token,
//     }

//     setSaveLoader(true)
//     setError("")

//     try {
//       const res = await axios.post(
//         `${import.meta.env.VITE_APP_BASE_URL}/api/company/furniture/range/update`,
//         {
//           company_id: Number(companyProfile.id),
//           min_range: Number.parseInt(min_range),
//           max_range: Number.parseInt(max_range),
//           price: Number.parseFloat(price),
//           extra_fee: Number.parseFloat(extra_fee) || 0,
//         },
//         { headers: headersFormData },
//       )

//       if (res.data?.success) {
//         setSuccess("Delivery range added successfully!")
//         setNewRange({ min_range: "", max_range: "", price: "", extra_fee: "" })
//         setShowAddForm(false)
//         getDeliveryRanges()
//         setTimeout(() => setSuccess(""), 3000)
//       }
//       setSaveLoader(false)
//     } catch (err) {
//       setError(err.response?.data?.message || "Failed to add delivery range")
//       setSaveLoader(false)
//     }
//   }

//   // Delete delivery range
//   const deleteDeliveryRange = async () => {
//     const headersFormData = {
//       "Content-Type": "application/json",
//       Authorization: user?.token,
//     }

//     setDelLoader(true)
//     try {
//       const res = await axios.delete(
//         `${import.meta.env.VITE_APP_BASE_URL}/api/company/furniture/range/delete/${deleteRangeId}`,
//         { headers: headersFormData },
//       )

//       if (res.data?.success) {
//         getDeliveryRanges()
//         setDeleteModal(false)
//         setSuccess("Delivery range deleted successfully!")
//         setTimeout(() => setSuccess(""), 3000)
//       }
//       setDelLoader(false)
//     } catch (err) {
//       setError(err.response?.data?.message || "Failed to delete range")
//       setDelLoader(false)
//     }
//   }

//   // Add city pricing with proper range isolation
//   const addCityPricing = async (rangeId ,index=0) => {
//     const cityData = addNewCityTax[rangeId] ?addNewCityTax[rangeId][index]:undefined;
//     if (!cityData) return;

//     const { state, county, city, zip_code, extra_price } = cityData

//     if (!city || !extra_price) {
//       setError("Please fill city name and extra price fields")
//       return
//     }

//     const headersFormData = {
//       "Content-Type": "application/json",
//       Authorization: user?.token,
//     }

//     setSaveLoader(true)
//     setError("")

//     try {
//       const res = await axios.post(
//         `${import.meta.env.VITE_APP_BASE_URL}/api/company/furniture/city-price/update`,
//         {
//           furniture_range_id: rangeId,
//           state: state || "",
//           county: county || "",
//           city,
//           zip_code: zip_code || "",
//           extra_price: Number.parseFloat(extra_price),
//         },
//         { headers: headersFormData },
//       )
// // debugger
//       if (res.data.statusCode === 200) {
//         setSuccess("City pricing added successfully!")
//         // Reset only the specific range's form data
//         let updatedNewCitiData = addNewCityTax[rangeId]?.filter((_, i) => i != index)
//         //
//      //   setDeliveryRanges(prev=>[...prev.filter((d)=>d.id !=rangeId)])
//         setAddNewCityTax((prev) => ({
//           ...prev,
//           [rangeId]:updatedNewCitiData,
//         }))
//         setShowCityForm((prev) => ({ ...prev, [rangeId]: false }))
//         getDeliveryRanges()
//         setTimeout(() => setSuccess(""), 3000)
//       }
//       setSaveLoader(false)
//     } catch (err) {
//       setError(err.response?.data?.message || "Failed to add city pricing")
//       setSaveLoader(false)
//     }
//   }

//   // Update delivery range with in-place editing
//   const updateDeliveryRange = async (rangeId) => {
//     const rangeData = editingRangeData[rangeId]
//     if (!rangeData) return

//     const { min_range, max_range, price, extra_fee } = rangeData

//     if (!min_range || !max_range || !price) {
//       setError("Please fill all required fields")
//       return
//     }

//     if (Number.parseInt(min_range) >= Number.parseInt(max_range)) {
//       setError("To miles must be greater than from miles")
//       return
//     }

//     const validationError = validateRangeContinuity(Number.parseInt(min_range), Number.parseInt(max_range), rangeId)
//     if (validationError) {
//       setError(validationError)
//       return
//     }

//     const headersFormData = {
//       "Content-Type": "application/json",
//       Authorization: user?.token,
//     }

//     setSaveLoader(true)
//     setError("")

//     try {
//       const res = await axios.post(
//         `${import.meta.env.VITE_APP_BASE_URL}/api/company/furniture/range/update/${rangeId}`,
//         {
//           company_id: companyProfile.id,
//           min_range: Number.parseInt(min_range),
//           max_range: Number.parseInt(max_range),
//           price: Number.parseFloat(price),
//           extra_fee: Number.parseFloat(extra_fee) || 0,
//         },
//         { headers: headersFormData },
//       )

//       if (res.data?.success) {
//         setSuccess("Delivery range updated successfully!")
//         setEditingRange(null)
//         setEditingRangeData((prev) => {
//           const newData = { ...prev }
//           delete newData[rangeId]
//           return newData
//         })
//         getDeliveryRanges()
//         setTimeout(() => setSuccess(""), 3000)
//       }
//       setSaveLoader(false)
//     } catch (err) {
//       setError(err.response?.data?.message || "Failed to update delivery range")
//       setSaveLoader(false)
//     }
//   }

//   // Update city pricing with in-place editing
//   const updateCityPricing = async (cityId, rangeId) => {
//     const cityData = editingCityData[cityId]
//     if (!cityData) return

//     const { state, county, city, zip_code, extra_price } = cityData

//     if (!city || !extra_price) {
//       setError("Please fill city name and extra price fields")
//       return
//     }

//     const headersFormData = {
//       "Content-Type": "application/json",
//       Authorization: user?.token,
//     }

//     setSaveLoader(true)
//     setError("")

//     try {
//       const res = await axios.post(
//         `${import.meta.env.VITE_APP_BASE_URL}/api/company/furniture/city-price/update/${cityId}`,
//         {
//           furniture_range_id: rangeId,
//           state: state || "",
//           county: county || "",
//           city,
//           zip_code: zip_code || "",
//           extra_price: Number.parseFloat(extra_price),
//         },
//         { headers: headersFormData },
//       )

//       if (res.data?.success) {
//         setSuccess("City pricing updated successfully!")
//         setEditingCity(null)
//         setEditingCityData((prev) => {
//           const newData = { ...prev }
//           delete newData[cityId]
//           return newData
//         })
//         getDeliveryRanges()
//         setTimeout(() => setSuccess(""), 3000)
//       }
//       setSaveLoader(false)
//     } catch (err) {
//       setError(err.response?.data?.message || "Failed to update city pricing")
//       setSaveLoader(false)
//     }
//   }

//   // Delete city pricing with confirmation
//   const deleteCityPricing = async () => {
//     const headersFormData = {
//       "Content-Type": "application/json",
//       Authorization: user?.token,
//     }

//     setDelLoader(true)
//     try {
//       const res = await axios.delete(
//         `${import.meta.env.VITE_APP_BASE_URL}/api/company/furniture/city-price/delete/${deleteCityId}`,
//         { headers: headersFormData },
//       )

//       if (res.data?.success) {
//         setSuccess("City pricing deleted successfully!")
//         setDeleteCityModal(false)
//         setDeleteCityId("")
//         setDeleteCityRangeId("")
//         getDeliveryRanges()
//         setTimeout(() => setSuccess(""), 3000)
//       }
//       setDelLoader(false)
//     } catch (err) {
//       setError(err.response?.data?.message || "Failed to delete city pricing")
//       setDelLoader(false)
//     }
//   }

//   // Get next range start value
//   const getNextRangeStart = () => {
//     if (deliveryRanges.length === 0) return 0
//     const sortedRanges = [...deliveryRanges].sort((a, b) => a.min_range - b.min_range)
//     return sortedRanges[sortedRanges.length - 1].max_range
//   }

//   // Toggle collapse for range
//   const toggleRangeCollapse = (rangeId) => {
//     setCollapsedRanges((prev) => ({
//       ...prev,
//       [rangeId]: !prev[rangeId],
//     }))
//   }

//   // Start editing range in-place
//   const startEditingRange = (range) => {
//     setEditingRange(range.id)
//     setEditingRangeData((prev) => ({
//       ...prev,
//       [range.id]: {
//         min_range: range.min_range.toString(),
//         max_range: range.max_range.toString(),
//         price: range.price.toString(),
//         extra_fee: range.extra_fee.toString(),
//       },
//     }))
//   }

//   // Cancel editing range
//   const cancelEditingRange = (rangeId) => {
//     setEditingRange(null)
//     setEditingRangeData((prev) => {
//       const newData = { ...prev }
//       delete newData[rangeId]
//       return newData
//     })
//   }

//   // Start editing city in-place
//   const startEditingCity = (city, rangeId) => {
//     setEditingCity(city.id)
//     setEditingCityData((prev) => ({
//       ...prev,
//       [city.id]: {
//         state: city.state || "",
//         county: city.county || "",
//         city: city.city,
//         zip_code: city.zip_code || "",
//         extra_price: city.extra_price.toString(),
//       },
//     }))
//   }

//   // Cancel editing city
//   const cancelEditingCity = (cityId) => {
//     setEditingCity(null)
//     setEditingCityData((prev) => {
//       const newData = { ...prev }
//       delete newData[cityId]
//       return newData
//     })
//   }

//   // Update new city price for specific range
//   const updateNewCityPrice = (rangeId, field, value ,index=0) => {
//     const updatedData = addNewCityTax[rangeId]?.length >index &&addNewCityTax[rangeId] ;
//     if(!updatedData){
//       return
//     }
//     updatedData[index] = {
//       ...updatedData[index],
//       [field]: value
//     }
//     setAddNewCityTax((prev) => ({
//       ...prev,
//       [rangeId]: updatedData,
//     }))
//   }

//   // Update editing range data
//   const updateEditingRangeData = (rangeId, field, value) => {
//     setEditingRangeData((prev) => ({
//       ...prev,
//       [rangeId]: {
//         ...prev[rangeId],
//         [field]: value,
//       },
//     }))
//   }

//   // Update editing city data
//   const updateEditingCityData = (cityId, field, value) => {
//     setEditingCityData((prev) => ({
//       ...prev,
//       [cityId]: {
//         ...prev[cityId],
//         [field]: value,
//       },
//     }))
//   }

//   useEffect(() => {
//     if (activeTab === "profile") {
//       getCompanyProfile()
//     } else if (activeTab === "delivery") {
//       getDeliveryRanges()
//     }
//   }, [activeTab, user?.token])

//   useEffect(() => {
//     const nextStart = getNextRangeStart()
//     setNewRange((prev) => ({ ...prev, min_range: nextStart.toString() }))
//   }, [deliveryRanges])

// console.log("add city tax--------------->", addNewCityTax)

// const handleCancelAddNewCityForTax= (rangeId , index)=>{
//    let updatedNewCitiData = addNewCityTax[rangeId]?.filter((_, i) => i != index)
//    setAddNewCityTax((prev) => ({
//           ...prev,
//           [rangeId]:updatedNewCitiData,
//         }))
// }
//   return (
//     <Fragment>
//       <div className="main-box">
//         <div className="content-header d-flex justify-content-between align-items-center">
//           <h3>Furniture Delivery Setup</h3>
//           {activeTab === "delivery" && companyProfile.id && (
//             <Button
//               variant="primary"
//               className="d-flex align-items-center gap-2"
//               onClick={() => setShowAddForm(!showAddForm)}
//               title="Add new delivery range"
//             >
//               <i className="fas fa-plus"></i> ADD New
//             </Button>
//           )}
//         </div>

//         {error && <Alert variant="danger">{error}</Alert>}
//         {success && <Alert variant="success">{success}</Alert>}

//         <div className="myfurnit_store_main">
//           <ul className="nav nav-tabs" id="myTab" role="tablist">
//             {tabs.map((tab) => (
//               <li className="nav-item" role="presentation" key={tab.id}>
//                 <button
//                   className={`nav-link ${activeTab === tab.id ? "active" : ""}`}
//                   type="button"
//                   onClick={() => setActiveTab(tab.id)}
//                 >
//                   {tab.name}
//                 </button>
//               </li>
//             ))}
//           </ul>

//           <div className="tab-content" id="myTabContent">
//             <div className="tab-pane fade show active" role="tabpanel">
//               {isLoader ? (
//                 <div className="eye-loader-frame m-5 p-5">
//                   <div className="eye-loader-spinner"></div>
//                 </div>
//               ) : (
//                 <>
//                   {activeTab === "profile" && (
//                     <div className="company-profile-form p-4">
//                       <h4>Company Profile Information</h4>
//                       <Form>
//                         <Row>
//                           <Col md={6}>
//                             <Form.Group className="mb-3">
//                               <Form.Label>Company Name *</Form.Label>
//                               <Form.Control
//                                 type="text"
//                                 value={companyProfile.company_name}
//                                 onChange={(e) =>
//                                   setCompanyProfile((prev) => ({ ...prev, company_name: e.target.value }))
//                                 }
//                                 placeholder="Enter company name"
//                               />
//                             </Form.Group>
//                           </Col>
//                           <Col md={6}>
//                             <Form.Group className="mb-3">
//                               <Form.Label>City *</Form.Label>
//                               <Form.Control
//                                 type="text"
//                                 value={companyProfile.city}
//                                 onChange={(e) => setCompanyProfile((prev) => ({ ...prev, city: e.target.value }))}
//                                 placeholder="Enter city"
//                               />
//                             </Form.Group>
//                           </Col>
//                         </Row>

//                         <Form.Group className="mb-3">
//                           <Form.Label>Address</Form.Label>
//                           <Form.Control
//                             type="text"
//                             value={companyProfile.address}
//                             onChange={(e) => setCompanyProfile((prev) => ({ ...prev, address: e.target.value }))}
//                             placeholder="Enter full address"
//                           />
//                         </Form.Group>

//                         <Row>
//                           <Col md={4}>
//                             <Form.Group className="mb-3">
//                               <Form.Label>State</Form.Label>
//                               <Form.Control
//                                 type="text"
//                                 value={companyProfile.state}
//                                 onChange={(e) => setCompanyProfile((prev) => ({ ...prev, state: e.target.value }))}
//                                 placeholder="Enter state"
//                               />
//                             </Form.Group>
//                           </Col>
//                           <Col md={4}>
//                             <Form.Group className="mb-3">
//                               <Form.Label>Postal Code</Form.Label>
//                               <Form.Control
//                                 type="text"
//                                 value={companyProfile.postal_code}
//                                 onChange={(e) =>
//                                   setCompanyProfile((prev) => ({ ...prev, postal_code: e.target.value }))
//                                 }
//                                 placeholder="Enter postal code"
//                               />
//                             </Form.Group>
//                           </Col>
//                           <Col md={4}>
//                             <Form.Group className="mb-3">
//                               <Form.Label>Country</Form.Label>
//                               <Form.Control
//                                 type="text"
//                                 value={companyProfile.country}
//                                 onChange={(e) => setCompanyProfile((prev) => ({ ...prev, country: e.target.value }))}
//                                 placeholder="Enter country"
//                               />
//                             </Form.Group>
//                           </Col>
//                         </Row>

//                         <div className="location-section mb-4">
//                           <div className="d-flex justify-content-between align-items-center mb-3">
//                             <h5>Business Location</h5>
//                             <div>
//                               <Button variant="outline-primary" size="sm" onClick={() => setShowMap(!showMap)}>
//                                 {showMap ? "Hide Map" : "📍 Select on Map"}
//                               </Button>
//                             </div>
//                           </div>

//                           {showMap && (
//                             <>
//                               {USE_Maps ? (
//                                 <GoogleMapsSelector
//                                   initialLatitude={companyProfile.latitude}
//                                   initialLongitude={companyProfile.longitude}
//                                   initialAddress={companyProfile.address}
//                                   onLocationChange={handleLocationChange}
//                                   onAddressChange={handleAddressChange}
//                                   googleMapsApiKey={Maps_API_KEY}
//                                   mapHeight="400px"
//                                   className="mb-3"
//                                 />
//                               ) : (
//                                 <LocationSelectorMap
//                                   initialLatitude={companyProfile.latitude}
//                                   initialLongitude={companyProfile.longitude}
//                                   initialAddress={companyProfile.address}
//                                   onLocationChange={handleLocationChange}
//                                   onAddressChange={handleAddressChange}
//                                   showDeliveryZones={deliveryRanges.length > 0}
//                                   deliveryZones={deliveryRanges.map((range) => ({
//                                     min_range: range.min_range,
//                                     max_range: range.max_range,
//                                   }))}
//                                   showAddressSearch={true}
//                                   showCurrentLocation={true}
//                                   showCoordinateInputs={true}
//                                   mapHeight="400px"
//                                   className="mb-3"
//                                 />
//                               )}
//                             </>
//                           )}

//                           {!showMap && (
//                             <Row>
//                               <Col md={6}>
//                                 <Form.Group className="mb-3">
//                                   <Form.Label>Latitude</Form.Label>
//                                   <Form.Control
//                                     type="number"
//                                     step="0.00000001"
//                                     value={companyProfile.latitude}
//                                     onChange={(e) =>
//                                       setCompanyProfile((prev) => ({ ...prev, latitude: e.target.value }))
//                                     }
//                                     placeholder="Enter latitude or select on map"
//                                   />
//                                 </Form.Group>
//                               </Col>
//                               <Col md={6}>
//                                 <Form.Group className="mb-3">
//                                   <Form.Label>Longitude</Form.Label>
//                                   <Form.Control
//                                     type="number"
//                                     step="0.00000001"
//                                     value={companyProfile.longitude}
//                                     onChange={(e) =>
//                                       setCompanyProfile((prev) => ({ ...prev, longitude: e.target.value }))
//                                     }
//                                     placeholder="Enter longitude or select on map"
//                                   />
//                                 </Form.Group>
//                               </Col>
//                             </Row>
//                           )}
//                         </div>

//                         <Button variant="primary" onClick={saveCompanyProfile} disabled={saveLoader}>
//                           {saveLoader ? <Spinner size="sm" /> : "Save Profile"}
//                         </Button>
//                       </Form>
//                     </div>
//                   )}

//                   {activeTab === "delivery" && (
//                     <div className="delivery-setup p-4">
//                       <h4>Delivery Fee Setup</h4>

//                       {!companyProfile.id && (
//                         <Alert variant="warning" className="mb-4">
//                           Please save your company profile first before setting up delivery ranges.
//                         </Alert>
//                       )}

//                       {/* Current Delivery Ranges */}
//                       {companyProfile.id && deliveryRanges.length > 0 && (
//                         <div className="existing-ranges">
//                           <h5 className="mb-3">Current Delivery Ranges</h5>
//                           {deliveryRanges
//                             .sort((a, b) => a.min_range - b.min_range)
//                             .map((range, index) => (
//                               <div key={range.id} className="card mb-3 border-0 shadow-sm">
//                                 <div className="card-body">
//                                   <div className="d-flex justify-content-between align-items-center">
//                                     <div className="d-flex align-items-center gap-3">
//                                       <Button
//                                         variant="link"
//                                         className="p-0 text-decoration-none"
//                                         onClick={() => toggleRangeCollapse(range.id)}
//                                         title="Toggle serviceable areas"
//                                       >
//                                         <i
//                                           className={`fas ${collapsedRanges[range.id] ? "fa-chevron-down" : "fa-chevron-right"
//                                             }`}
//                                         ></i>
//                                       </Button>

//                                       {/* In-place editing for range */}
//                                       {editingRange === range.id ? (
//                                         <div className="d-flex align-items-center gap-2">
//                                           <Form.Control
//                                             type="number"
//                                             size="sm"
//                                             style={{ width: "80px" }}
//                                             value={editingRangeData[range.id]?.min_range || ""}
//                                             onChange={(e) =>
//                                               updateEditingRangeData(range.id, "min_range", e.target.value)
//                                             }
//                                             placeholder="From"
//                                           />
//                                           <span>-</span>
//                                           <Form.Control
//                                             type="number"
//                                             size="sm"
//                                             style={{ width: "80px" }}
//                                             value={editingRangeData[range.id]?.max_range || ""}
//                                             onChange={(e) =>
//                                               updateEditingRangeData(range.id, "max_range", e.target.value)
//                                             }
//                                             placeholder="To"
//                                           />
//                                           <span>miles</span>
//                                           <div className="d-flex align-items-center gap-1">
//                                             <span>Base Price: $</span>
//                                             <Form.Control
//                                               type="number"
//                                               size="sm"
//                                               step="0.01"
//                                               style={{ width: "100px" }}
//                                               value={editingRangeData[range.id]?.price || ""}
//                                               onChange={(e) =>
//                                                 updateEditingRangeData(range.id, "price", e.target.value)
//                                               }
//                                               placeholder="Price"
//                                             />
//                                           </div>
//                                           <div className="d-flex align-items-center gap-1">
//                                             <span>Extra Fee: $</span>
//                                             <Form.Control
//                                               type="number"
//                                               size="sm"
//                                               step="0.01"
//                                               style={{ width: "100px" }}
//                                               value={editingRangeData[range.id]?.extra_fee || ""}
//                                               onChange={(e) =>
//                                                 updateEditingRangeData(range.id, "extra_fee", e.target.value)
//                                               }
//                                               placeholder="Extra"
//                                             />
//                                           </div>
//                                         </div>
//                                       ) : (
//                                         <div>
//                                           <h6 className="mb-1 fw-bold">
//                                             {range.min_range} - {range.max_range} miles
//                                           </h6>
//                                           <span className="text-muted">Base Price: ${range.price}</span>
//                                           {range.extra_fee > 0 && (
//                                             <span className="text-muted ms-3">Extra Fee: ${range.extra_fee}</span>
//                                           )}
//                                         </div>
//                                       )}
//                                     </div>

//                                     <div className="d-flex gap-2">
//                                       {editingRange === range.id ? (
//                                         <>
//                                           <Button
//                                             variant="success"
//                                             size="sm"
//                                             title="Save changes"
//                                             onClick={() => updateDeliveryRange(range.id)}
//                                             disabled={saveLoader}
//                                           >
//                                             {saveLoader ? <Spinner size="sm" /> : <i className="fas fa-save"></i>}
//                                           </Button>
//                                           <Button
//                                             variant="outline-secondary"
//                                             size="sm"
//                                             title="Cancel editing"
//                                             onClick={() => cancelEditingRange(range.id)}
//                                           >
//                                             <i className="fas fa-times"></i>
//                                           </Button>
//                                         </>
//                                       ) : (
//                                         <>
//                                           <Button
//                                             variant="outline-primary"
//                                             size="sm"
//                                             title="Edit this range"
//                                             onClick={() => startEditingRange(range)}
//                                           >
//                                             <i className="fas fa-edit"></i>
//                                           </Button>
//                                           {index === deliveryRanges.length - 1 && (
//                                             <Button
//                                               variant="outline-danger"
//                                               size="sm"
//                                               title="Delete this range"
//                                               onClick={() => {
//                                                 setDeleteRangeId(range.id)
//                                                 setDeleteModal(true)
//                                               }}
//                                             >
//                                               <i className="fas fa-trash"></i>
//                                             </Button>
//                                           )}
//                                         </>
//                                       )}
//                                     </div>
//                                   </div>

//                                   {/* Collapsible Serviceable Areas */}
//                                   <Collapse in={collapsedRanges[range.id]}>
//                                     <div className="mt-3">
//                                       <div className="d-flex justify-content-between align-items-center mb-3">
//                                         <h6 className="mb-0 fw-semibold">Serviceable Areas</h6>
//                                         <Button
//                                           variant="success"
//                                           size="sm"
//                                           className="d-flex align-items-center gap-2"
//                                           title="Add city tax"
//                                           onClick={() =>
//                                             setAddNewCityTax((prev) => ({
//                                               ...prev,
//                                               [range.id]: [initialAddNewCityTaxData]
//                                              ,
//                                             }))
//                                           }
//                                         >
//                                           <i className="fas fa-plus-circle"></i> Add city tax
//                                         </Button>
//                                       </div>
//                                       <ServiceAbleAreaForExtraTax data={range.cityPrices} />

//                                       {/* Add City Form */}
//                                       {addNewCityTax[range.id] && (
//                                         <div className="card border-0 bg-light">
//                                           <div className="card-body">
//                                             <h6 className="mb-3 d-flex align-items-center gap-2">
//                                               <i className="fas fa-map-marker-alt"></i>
//                                               Add City Tax
//                                             </h6>
//                                             {addNewCityTax[range.id]?.map((newCityPriceData , index) => (
//                                               <AddServiceableAreaForTax
//                                               onSave={()=>{addCityPricing(range.id, index)}}
//                                               onCancel={()=>{handleCancelAddNewCityForTax(range?.id ,index )}}
//                                               newCityPrices={newCityPriceData}
//                                               updateNewCityPrice={(field, value) => updateNewCityPrice(range.id, field, value, index )}/>
//                                             ))}

//                                           </div>
//                                         </div>
//                                       )}
//                                     </div>
//                                   </Collapse>
//                                 </div>
//                               </div>
//                             ))}
//                         </div>
//                       )}

//                       {companyProfile.id && deliveryRanges.length === 0 && (
//                         <div className="no-delivery-setup mb-4">
//                           <Alert variant="info">
//                             No delivery fees setup yet. Click "ADD New +" to add your first delivery range.
//                           </Alert>
//                         </div>
//                       )}

//                       {/* Add New Range Form */}
//                       {companyProfile.id && showAddForm && (
//                         <div className="card border-0 shadow-sm mb-4">
//                           <div className="card-body">
//                             <div className="d-flex justify-content-between align-items-center mb-3">
//                               <h5 className="mb-0 fw-bold text-primary">
//                                 <i className="fas fa-plus"></i> Add New Delivery Range
//                               </h5>Select Package

//                               <Button
//                                 variant="outline-secondary"
//                                 size="sm"
//                                 title="Close form"
//                                 onClick={() => setShowAddForm(false)}
//                               >
//                                 <i className="fas fa-times"></i>
//                               </Button>
//                             </div>

//                             <Row className="g-3">
//                               <Col md={3}>
//                                 <Form.Group>
//                                   <Form.Label className="fw-semibold">From Miles</Form.Label>
//                                   <Form.Control
//                                     type="number"
//                                     value={newRange.min_range}
//                                     onChange={(e) => setNewRange((prev) => ({ ...prev, min_range: e.target.value }))}
//                                     placeholder="0"
//                                     readOnly={deliveryRanges.length > 0}
//                                     className="form-control-lg"
//                                   />
//                                 </Form.Group>
//                               </Col>
//                               <Col md={3}>
//                                 <Form.Group>
//                                   <Form.Label className="fw-semibold">To Miles</Form.Label>
//                                   <Form.Control
//                                     type="number"
//                                     value={newRange.max_range}
//                                     onChange={(e) => setNewRange((prev) => ({ ...prev, max_range: e.target.value }))}
//                                     placeholder="40"
//                                     className="form-control-lg"
//                                   />
//                                 </Form.Group>
//                               </Col>
//                               <Col md={3}>
//                                 <Form.Group>
//                                   <Form.Label className="fw-semibold">Base Price ($)</Form.Label>
//                                   <Form.Control
//                                     type="number"
//                                     step="0.01"
//                                     value={newRange.price}
//                                     onChange={(e) => setNewRange((prev) => ({ ...prev, price: e.target.value }))}
//                                     placeholder="50.00"
//                                     className="form-control-lg"
//                                   />
//                                 </Form.Group>
//                               </Col>
//                               <Col md={3}>
//                                 <Form.Group>
//                                   <Form.Label className="fw-semibold">Extra Fee ($)</Form.Label>
//                                   <Form.Control
//                                     type="number"
//                                     step="0.01"
//                                     value={newRange.extra_fee}
//                                     onChange={(e) => setNewRange((prev) => ({ ...prev, extra_fee: e.target.value }))}
//                                     placeholder="0.00"
//                                     className="form-control-lg"
//                                   />
//                                 </Form.Group>
//                               </Col>
//                             </Row>

//                             <div className="d-flex justify-content-between align-items-center mt-4">
//                               <Button
//                                 variant="primary"
//                                 size="lg"
//                                 onClick={addDeliveryRange}
//                                 disabled={saveLoader || !newRange.min_range || !newRange.max_range || !newRange.price}
//                                 className="d-flex align-items-center gap-2"
//                                 title="Save range"
//                               >
//                                 {saveLoader ? (
//                                   <Spinner size="sm" />
//                                 ) : (
//                                   <>
//                                     <i className="fas fa-save"></i> Save Range
//                                   </>
//                                 )}
//                               </Button>
//                               <small className="text-muted">
//                                 * Ranges must be continuous with no gaps. Next range will start from{" "}
//                                 {getNextRangeStart()} miles.
//                               </small>
//                             </div>
//                           </div>
//                         </div>
//                       )}
//                     </div>
//                   )}
//                 </>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Delete Range Confirmation Modal */}
//       <Modal show={deleteModal} onHide={() => setDeleteModal(false)} backdrop="static" keyboard={false}>
//         <Modal.Header closeButton>
//           <Modal.Title>Delete Delivery Range</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           Are you sure you want to delete this delivery range? This will also delete all associated city pricing.
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setDeleteModal(false)}>
//             Cancel
//           </Button>
//           <Button variant="danger" disabled={delLoader} onClick={deleteDeliveryRange}>
//             {delLoader ? <Spinner size="sm" /> : "Delete"}
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Delete City Confirmation Modal */}
//       <Modal show={deleteCityModal} onHide={() => setDeleteCityModal(false)} backdrop="static" keyboard={false}>
//         <Modal.Header closeButton>
//           <Modal.Title>Delete City Pricing</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>Are you sure you want to delete this city pricing?</Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setDeleteCityModal(false)}>
//             Cancel
//           </Button>
//           <Button variant="danger" disabled={delLoader} onClick={deleteCityPricing}>
//             {delLoader ? <Spinner size="sm" /> : "Delete"}
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </Fragment>
//   )
// }

// export default FurnitureDeliverySetup

// const ServiceAbleAreaForExtraTax = ({ data }) => {
//   const [cityEditId, setCityEditId] = useState("");

//   return (
//     <>
//       {data.length > 0 && (
//         <div className="city-list bg-light rounded p-3 mb-3">
//           <div className="row fw-bold border-bottom pb-2 mb-2 small text-muted">
//             <div className="col-3">City</div>
//             <div className="col-2">ZIP Code</div>
//             <div className="col-2">Extra Cost</div>
//             <div className="col-1">Actions</div>
//           </div>

//           {data.map((city) =>
//             cityEditId === city.id ? (
//               <AddServiceableAreaForTax key={city.id} newCityPrices={city} />
//             ) : (
//               <div key={city.id} className="row py-2 border-bottom align-items-center">
//                 <div className="col-3">{city.city}</div>
//                 <div className="col-2">{city.zip_code || "-"}</div>
//                 <div className="col-2 text-success fw-bold">+${city.extra_price}</div>
//                 <div className="col-1">
//                   <div className="d-flex gap-1">
//                     <Button
//                       variant="outline-primary"
//                       size="sm"
//                       title="Edit city pricing"
//                       onClick={() =>
//                         setCityEditId(city.id) // Updated: setCityEditId instead of setEditingCity
//                       }
//                     >
//                       <i className="fas fa-edit"></i>
//                     </Button>
//                     <Button
//                       variant="outline-danger"
//                       size="sm"
//                       title="Delete city pricing"
//                       onClick={() => deleteCityPricing(city.id)} // Removed range.id if not defined
//                     >
//                       <i className="fas fa-trash"></i>
//                     </Button>
//                   </div>
//                 </div>
//               </div>
//             )
//           )}
//         </div>
//       )}
//     </>
//   );
// };

// const AddServiceableAreaForTax = ({ newCityPrices , onSave ,onCancel , updateNewCityPrice }) => {

//   return (
//     <>
//       <Row className="g-3">
//         <Col md={3}>
//           <Form.Group>
//             <Form.Label className="fw-semibold">City *</Form.Label>
//             <Form.Control
//               type="text"
//               placeholder="Enter city name"
//               value={newCityPrices?.city || ""}
//               onChange={(e) =>
//                  updateNewCityPrice("city", e.target.value)
//               }
//               className="form-control-lg"
//             />
//           </Form.Group>
//         </Col>
//         <Col md={2}>
//           <Form.Group>
//             <Form.Label className="fw-semibold">ZIP Code</Form.Label>
//             <Form.Control
//               type="text"
//               placeholder="ZIP"
//               value={newCityPrices?.zip_code || ""}
//               onChange={(e) =>
//                  updateNewCityPrice( "zip_code", e.target.value)
//               }
//               className="form-control-lg"
//             />
//           </Form.Group>
//         </Col>
//         <Col md={2}>
//           <Form.Group>
//             <Form.Label className="fw-semibold">Extra Cost ($) *</Form.Label>
//             <Form.Control
//               type="number"
//               step="0.01"
//               placeholder="0.00"
//               value={newCityPrices?.extra_price || ""}
//               onChange={(e) =>
//                 updateNewCityPrice( "extra_price", e.target.value)
//               }
//               className="form-control-lg"
//             />
//           </Form.Group>
//         </Col>
//         <Col md={1} className="d-flex align-items-end">
//           <div className="d-flex flex-column w-100 gap-2">
//             <Button
//               variant="success"
//               size="lg"
//               title="Save city pricing"
//               onClick={() =>onSave()}
//               // disabled={saveLoader}
//               className="d-flex align-items-center justify-content-center"
//             >
//               <i className="fas fa-save"></i>
//             </Button>
//             <Button
//               variant="outline-secondary"
//               size="lg"
//               title="Cancel"
//               onClick={() => {
//                 onCancel()
//                 }}
//               className="d-flex align-items-center justify-content-center"
//             >
//               <i className="fas fa-times"></i>
//             </Button>
//           </div>
//         </Col>
//       </Row>
//     </>
//   )
// }

// 4th version

"use client";

//1

import { Fragment, useEffect, useState } from "react";
import {
  Modal,
  Spinner,
  Button,
  Form,
  Row,
  Col,
  Alert,
  Collapse,
  ToggleButtonGroup,
  ToggleButton,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import axios from "axios";
import { useUserState } from "../../../Contexts/UserContext";
import LocationSelectorMap from "@common/LocationSelectorMap";
import GoogleMapsSelector from "@common/GoogleMapsSelector";
import { set } from "store";
import { Popconfirm } from "antd";
import { de, fi, is } from "date-fns/locale";

const tabs = [
  { id: "profile", name: "Profile Setup" },
  { id: "delivery", name: "Delivery Fee" },
  { id: "DeliverRangeList", name: "Delivery Range" },
];

const initialAddNewCityTaxData = {
  state: "",
  county: "",
  city: "",
  zip_code: "",
  extra_price: "",
};

// Configuration - set your Google Maps API key here
const Maps_API_KEY = import.meta.env.VITE_Maps_API_KEY || "";
const USE_Maps = !!Maps_API_KEY; // Use Google Maps if API key is available

const FurnitureDeliverySetup = () => {
  const { user } = useUserState();
  const [activeTab, setActiveTab] = useState("profile");
  const [isLoader, setIsLoader] = useState(false);
  const [saveLoader, setSaveLoader] = useState(false);
  const [isManual, setIsManual] = useState(false);
  const [pendingValue, setPendingValue] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [basePrice, setBasePrice] = useState("");
  // Company Profile State
  const [companyProfile, setCompanyProfile] = useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  const [categoryList, setCategoryList] = useState([]);
  // Delivery Ranges State
  const [deliveryRanges, setDeliveryRanges] = useState([]);
  const [companyDeliveryRanges, setCompanyDeliveryRanges] = useState([]);
  const [newRange, setNewRange] = useState({
    min_range: "",
    max_range: "",
    price: "",
    extra_fee: "",
    furniture_type: "",
  });

  // City Pricing State - Now managed per range
  const [cityPricing, setCityPricing] = useState({});
  const [showCityForm, setShowCityForm] = useState({});
  const [newCityPrices, setNewCityPrices] = useState({}); // Changed to handle multiple ranges

  // Error and Success States
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteRangeId, setDeleteRangeId] = useState("");
  const [delLoader, setDelLoader] = useState(false);
  const [delStoreLoader, setDelStoreLoader] = useState(false);

  // Map visibility state
  const [showMap, setShowMap] = useState(true);

  // Enhanced state variables for in-place editing
  const [showAddForm, setShowAddForm] = useState(false);
  const [editingRange, setEditingRange] = useState(null);
  const [editingRangeData, setEditingRangeData] = useState({});
  const [editingCity, setEditingCity] = useState(null);
  const [editingCityData, setEditingCityData] = useState({});
  const [collapsedRanges, setCollapsedRanges] = useState({});

  // Delete city modal state
  const [deleteCityModal, setDeleteCityModal] = useState(false);
  const [deleteCityId, setDeleteCityId] = useState("");
  const [deleteCityRangeId, setDeleteCityRangeId] = useState("");
  const [addNewCityTax, setAddNewCityTax] = useState({});
  const blankProfile = () => ({
    id: null,
    company_name: " ",
    description: "",
    address: "",
    city: "",
    state: "",
    postal_code: "",
    country: "",
    latitude: "",
    longitude: "",
    furniture_type: "",
  });
  // Handle location change from map component
  const handleLocationChange = (index, locationData) => {
    setCompanyProfile((prev) =>
      prev.map((p, i) =>
        i === index
          ? {
              ...p,
              latitude: locationData.latitude,
              longitude: locationData.longitude,
              address: locationData.address || p.address,
              city: locationData.city || p.city,
              state: locationData.state || p.state,
              country: locationData.country || p.country,
              postal_code: locationData.zipCode || p.postal_code,
            }
          : p
      )
    );
  };
  const checkManualData = async () => {
    const headersFormData = {
      "Content-Type": "application/json",
      Authorization: user?.token,
    };
    if (user?.token) {
      // setIsLoader(true);
      try {
        const res = await axios.get(
          `${
            import.meta.env.VITE_APP_BASE_URL
          }/api/company/check-manual-data/${selectedCompanyId}`,
          { headers: headersFormData }
        );
        return res.data?.data?.has_manual_data || false;
        // setIsLoader(false);
      } catch (err) {
        console.log(err);
        // setIsLoader(false);
      }
    }
  };

  const handleSwitchChange = async (e) => {
    const newManualValue = e.target.checked;
    if (newManualValue == 0) {
      confirmChange(newManualValue);
      setPendingValue(newManualValue);
    } else {
      const hasManualData = await checkManualData();
      if (hasManualData == true) {
        confirmChange(newManualValue);
        setPendingValue(newManualValue);
      } else {
        setPendingValue(newManualValue);
        setShowConfirmModal(true);
      }
    }
  };
  // Handle address change from map component
  const handleAddressChange = (index, address) => {
    setCompanyProfile((prev) =>
      prev.map((p, i) => (i === index ? { ...p, address } : p))
    );
  };

  // Fetch company profile
  const getCompanyProfiles = async () => {
    const headersFormData = {
      "Content-Type": "application/json",
      Authorization: user?.token,
    };
    if (!user?.token) return;
    setIsLoader(true);
    try {
      const res = await axios.get(
        `${import.meta.env.VITE_APP_BASE_URL}/api/company/get`,
        { headers: headersFormData }
      );
      const data = res.data?.data || [];
      // If no profiles, set one blank form
      if (data.length === 0) {
        setCompanyProfile([blankProfile()]);
      } else {
        setCompanyProfile(data);
      }
    } catch (err) {
      console.log("No company profiles found");
    } finally {
      setIsLoader(false);
    }
  };

  // Fetch delivery ranges
  const getDeliveryRanges = async () => {
    const headersFormData = {
      "Content-Type": "application/json",
      Authorization: user?.token,
    };
    if (user?.token && selectedCompanyId) {
      setIsLoader(true);
      try {
        const res = await axios.get(
          `${
            import.meta.env.VITE_APP_BASE_URL
          }/api/company/furniture/ranges/${selectedCompanyId}/${
            isManual ? 1 : 0
          }`,
          { headers: headersFormData }
        );
        if (res.data?.data) {
          setDeliveryRanges(res.data.data);
          // Extract city pricing from ranges
          const cityPricingData = {};
          const newCityPricesData = {};
          res.data.data.forEach((range) => {
            if (range.FurnitureDeliveryCityPrices) {
              cityPricingData[range.id] = range.FurnitureDeliveryCityPrices;
            }
            // Initialize empty form data for each range
            newCityPricesData[range.id] = {
              state: "",
              county: "",
              city: "",
              zip_code: "",
              extra_price: "",
            };
          });
          setCityPricing(cityPricingData);
          setNewCityPrices(newCityPricesData);
        }
        setIsLoader(false);
      } catch (err) {
        console.log(err);
        setIsLoader(false);
      }
    }
  };
  const getCompanyDeliveryRanges = async () => {
    const headersFormData = {
      "Content-Type": "application/json",
      Authorization: user?.token,
    };
    if (user?.token) {
      // setIsLoader(true);
      try {
        const res = await axios.get(
          `${
            import.meta.env.VITE_APP_BASE_URL
          }/api/company/get-company-delivery-range`,
          { headers: headersFormData }
        );
        if (res.data?.data) {
          setCompanyDeliveryRanges(res.data.data);
        }
        // setIsLoader(false);
      } catch (err) {
        console.log(err);
        // setIsLoader(false);
      }
    }
  };
  // Save company profile
  const saveCompanyProfile = async (profile) => {
    const headersFormData = {
      "Content-Type": "application/json",
      Authorization: user?.token,
    };
    setSaveLoader(true);
    setError("");
    setSuccess("");
    try {
      let res;
      if (profile.id) {
        res = await axios.put(
          `${import.meta.env.VITE_APP_BASE_URL}/api/company/update/${
            profile.id
          }`,
          profile,
          { headers: headersFormData }
        );
      } else {
        res = await axios.post(
          `${import.meta.env.VITE_APP_BASE_URL}/api/company/create`,
          profile,
          { headers: headersFormData }
        );
      }
      if (res.data?.statusCode === 200 && res.data.data) {
        setSuccess("Company profile saved successfully!");
        setTimeout(() => setSuccess(""), 3000);
        getCompanyProfiles();
      }
    } catch (err) {
      setError(err.response?.data?.message || "Failed to save profile");
    } finally {
      setSaveLoader(false);
    }
  };
  // Delete Company Store
  const deleteStore = async (id) => {
    const headersFormData = {
      "Content-Type": "application/json",
      Authorization: user?.token,
    };

    setDelStoreLoader(true);
    try {
      const res = await axios.delete(
        `${import.meta.env.VITE_APP_BASE_URL}/api/company/delete-store/${id}`,
        { headers: headersFormData }
      );

      if (res.data?.statusCode) {
        setSuccess("Delivery range deleted successfully!");
        setTimeout(() => setSuccess(""), 3000);
        getCompanyProfiles();
      }
      setDelStoreLoader(false);
    } catch (err) {
      setError(err.response?.data?.message || "Failed to delete range");
      setDelStoreLoader(false);
    }
  };

  // Validate range continuity
  const validateRangeContinuity = (
    newFromMiles,
    newToMiles,
    excludeRangeId = null,
    furniture_type
  ) => {
    const sortedRanges = [...deliveryRanges]
      .filter((range) => range.id !== excludeRangeId)
      .sort((a, b) => a.min_range - b.min_range);

    for (let i = 0; i < sortedRanges.length; i++) {
      const range = sortedRanges[i];
      if (
        (newFromMiles >= range.min_range &&
          newFromMiles < range.max_range &&
          range?.furniture_type == furniture_type) ||
        (newToMiles > range.min_range &&
          newToMiles <= range.max_range &&
          range?.furniture_type == furniture_type) ||
        (newFromMiles <= range.min_range &&
          newToMiles >= range.max_range &&
          range?.furniture_type == furniture_type)
      ) {
        return "Range overlaps with existing range";
      }
    }
    const packageRanges = sortedRanges.filter(
      (range) => range.furniture_type === furniture_type
    );

    if (packageRanges.length > 0) {
      const lastRange = packageRanges[packageRanges.length - 1];
      if (newFromMiles !== lastRange.max_range && newFromMiles !== 0) {
        return "Range must be continuous. Start from where the last range ended.";
      }
    }

    return null;
  };

  // Add delivery range
  const addDeliveryRange = async () => {
    const { min_range, max_range, price, extra_fee, furniture_type } = newRange;
    if (!min_range || !max_range || !price || !furniture_type) {
      setError("Please fill all required fields");
      return;
    }

    if (Number.parseInt(min_range) >= Number.parseInt(max_range)) {
      setError("To miles must be greater than from miles");
      return;
    }

    const validationError = validateRangeContinuity(
      Number.parseInt(min_range),
      Number.parseInt(max_range),
      null,
      furniture_type
    );
    if (validationError) {
      setError(validationError);
      return;
    }

    const headersFormData = {
      "Content-Type": "application/json",
      Authorization: user?.token,
    };

    setSaveLoader(true);
    setError("");
    try {
      const res = await axios.post(
        `${
          import.meta.env.VITE_APP_BASE_URL
        }/api/company/furniture/range/update`,
        {
          company_id: Number(selectedCompanyId),
          min_range: Number.parseInt(min_range),
          max_range: Number.parseInt(max_range),
          price: Number.parseFloat(price),
          furniture_type: furniture_type,
          // extra_fee: Number.parseFloat(extra_fee) || 0,
          extra_fee: 0,
        },
        { headers: headersFormData }
      );

      if (res.data?.statusCode === 200) {
        setSuccess("Delivery range added successfully!");
        setNewRange({
          min_range: "",
          max_range: "",
          price: "",
          extra_fee: "",
          furniture_type: "",
        });
        setShowAddForm(false);
        getDeliveryRanges();
        setTimeout(() => setSuccess(""), 3000);
      }
      setSaveLoader(false);
    } catch (err) {
      setError(err.response?.data?.message || "Failed to add delivery range");
      setSaveLoader(false);
    }
  };
  useEffect(() => {
    getDeliveryRanges();
  }, [isManual]);
  // Delete delivery range
  const deleteDeliveryRange = async () => {
    const headersFormData = {
      "Content-Type": "application/json",
      Authorization: user?.token,
    };

    setDelLoader(true);
    try {
      const res = await axios.delete(
        `${
          import.meta.env.VITE_APP_BASE_URL
        }/api/company/furniture/range/delete/${deleteRangeId}`,
        { headers: headersFormData }
      );

      if (res.data?.statusCode) {
        getDeliveryRanges();
        setDeleteModal(false);
        setSuccess("Delivery range deleted successfully!");
        setTimeout(() => setSuccess(""), 3000);
      }
      setDelLoader(false);
    } catch (err) {
      setError(err.response?.data?.message || "Failed to delete range");
      setDelLoader(false);
    }
  };

  // Add city pricing with proper range isolation
  const addCityPricing = async (rangeId, index = 0) => {
    const cityData = addNewCityTax[rangeId]
      ? addNewCityTax[rangeId][index]
      : undefined;
    if (!cityData) return;

    const { state, county, city, zip_code, extra_price } = cityData;

    if (!city || !extra_price) {
      setError("Please fill city name and extra price fields");
      return;
    }

    const headersFormData = {
      "Content-Type": "application/json",
      Authorization: user?.token,
    };

    setSaveLoader(true);
    setError("");
    try {
      const res = await axios.post(
        `${
          import.meta.env.VITE_APP_BASE_URL
        }/api/company/furniture/city-price/update`,
        {
          furniture_range_id: rangeId,
          state: state || "",
          county: county || "",
          city,
          zip_code: zip_code || "",
          extra_price: Number.parseFloat(extra_price),
        },
        { headers: headersFormData }
      );

      if (res.data.statusCode === 200) {
        setSuccess("City pricing added successfully!");
        // Reset only the specific range's form data
        const updatedNewCitiData = addNewCityTax[rangeId]?.filter(
          (_, i) => i != index
        );
        setAddNewCityTax((prev) => ({
          ...prev,
          [rangeId]: updatedNewCitiData,
        }));
        setShowCityForm((prev) => ({ ...prev, [rangeId]: false }));
        getDeliveryRanges();
        setTimeout(() => setSuccess(""), 3000);
      }
      setSaveLoader(false);
    } catch (err) {
      setError(err.response?.data?.message || "Failed to add city pricing");
      setSaveLoader(false);
    }
  };

  // Update delivery range with in-place editing
  const updateDeliveryRange = async (rangeId) => {
    const rangeData = editingRangeData[rangeId];
    if (!rangeData) return;

    const { min_range, max_range, price, extra_fee, furniture_type } =
      rangeData;

    if (!min_range || !max_range || !price || !furniture_type) {
      setError("Please fill all required fields");
      return;
    }

    if (Number.parseInt(min_range) >= Number.parseInt(max_range)) {
      setError("To miles must be greater than from miles");
      return;
    }

    const validationError = validateRangeContinuity(
      Number.parseInt(min_range),
      Number.parseInt(max_range),
      rangeId,
      furniture_type
    );
    if (validationError) {
      setError(validationError);
      return;
    }

    const headersFormData = {
      "Content-Type": "application/json",
      Authorization: user?.token,
    };

    setSaveLoader(true);
    setError("");
    try {
      const res = await axios.post(
        `${
          import.meta.env.VITE_APP_BASE_URL
        }/api/company/furniture/range/update/${rangeId}`,
        {
          company_id: companyProfile.id,
          min_range: Number.parseInt(min_range),
          max_range: Number.parseInt(max_range),
          price: Number.parseFloat(price),
          furniture_type: Number.parseFloat(furniture_type),
          extra_fee: 0,
          // extra_fee: Number.parseFloat(extra_fee) || 0,
        },
        { headers: headersFormData }
      );

      if (res.data) {
        setSuccess("Delivery range updated successfully!");
        setEditingRange(null);
        setEditingRangeData((prev) => {
          const newData = { ...prev };
          delete newData[rangeId];
          return newData;
        });
        getDeliveryRanges();
        setTimeout(() => setSuccess(""), 3000);
      }
      setSaveLoader(false);
    } catch (err) {
      setError(
        err.response?.data?.message || "Failed to update delivery range"
      );
      setSaveLoader(false);
    }
  };

  // Update city pricing with in-place editing
  const updateCityPricing = async (cityId, rangeId) => {
    const cityData = editingCityData[cityId];
    if (!cityData) return;

    const { state, county, city, zip_code, extra_price } = cityData;

    if (!city || !extra_price) {
      setError("Please fill city name and extra price fields");
      return;
    }

    const headersFormData = {
      "Content-Type": "application/json",
      Authorization: user?.token,
    };

    setSaveLoader(true);
    setError("");
    try {
      const res = await axios.post(
        `${
          import.meta.env.VITE_APP_BASE_URL
        }/api/company/furniture/city-price/update/${cityId}`,
        {
          furniture_range_id: rangeId,
          state: state || "",
          county: county || "",
          city,
          zip_code: zip_code || "",
          extra_price: Number.parseFloat(extra_price),
        },
        { headers: headersFormData }
      );

      if (res.data?.statusCode === 200) {
        setSuccess("City pricing updated successfully!");
        setEditingCity(null);
        setEditingCityData((prev) => {
          const newData = { ...prev };
          delete newData[cityId];
          return newData;
        });
        getDeliveryRanges();
        setTimeout(() => setSuccess(""), 3000);
      }
      setSaveLoader(false);
    } catch (err) {
      setError(err.response?.data?.message || "Failed to update city pricing");
      setSaveLoader(false);
    }
  };

  // Delete city pricing with confirmation
  const deleteCityPricing = async () => {
    const headersFormData = {
      "Content-Type": "application/json",
      Authorization: user?.token,
    };

    setDelLoader(true);
    try {
      const res = await axios.delete(
        `${
          import.meta.env.VITE_APP_BASE_URL
        }/api/company/furniture/city-price/delete/${deleteCityId}`,
        { headers: headersFormData }
      );

      if (res?.status === 200) {
        setSuccess("City pricing deleted successfully!");
        setDeleteCityModal(false);
        setDeleteCityId("");
        setDeleteCityRangeId("");
        getDeliveryRanges();
        setTimeout(() => setSuccess(""), 3000);
      }
      setDelLoader(false);
    } catch (err) {
      setError(err.response?.data?.message || "Failed to delete city pricing");
      setDelLoader(false);
    }
  };

  // Handle delete city pricing - sets up the modal
  const handleDeleteCityPricing = (cityId, rangeId) => {
    setDeleteCityId(cityId);
    setDeleteCityRangeId(rangeId);
    setDeleteCityModal(true);
  };

  // Get next range start value
  const getNextRangeStartForPackage = (packageId) => {
    if (!packageId) return 0;
    const packageRanges = deliveryRanges.filter(
      (range) => range.furniture_type == packageId
    );
    if (packageRanges.length == 0) {
      return 0;
    }
    const sortedRanges = packageRanges.sort(
      (a, b) => a.min_range - b.min_range
    );
    return sortedRanges[sortedRanges.length - 1].max_range;
  };
  // Function to check if package has previous range(s)
  const packageHasPreviousRanges = (packageId) => {
    return deliveryRanges.some((range) => range.furniture_type == packageId);
  };
  // Toggle collapse for range
  const toggleRangeCollapse = (rangeId) => {
    setCollapsedRanges((prev) => ({
      ...prev,
      [rangeId]: !prev[rangeId],
    }));
  };

  // Start editing range in-place
  const startEditingRange = (range) => {
    setEditingRange(range.id);
    setEditingRangeData((prev) => ({
      ...prev,
      [range.id]: {
        min_range: range.min_range.toString(),
        max_range: range.max_range.toString(),
        price: range.price.toString(),
        extra_fee: range.extra_fee.toString(),
      },
    }));
  };

  // Cancel editing range
  const cancelEditingRange = (rangeId) => {
    setEditingRange(null);
    setEditingRangeData((prev) => {
      const newData = { ...prev };
      delete newData[rangeId];
      return newData;
    });
  };

  // Start editing city in-place
  const startEditingCity = (city, rangeId) => {
    setEditingCity(city.id);
    setEditingCityData((prev) => ({
      ...prev,
      [city.id]: {
        state: city.state || "",
        county: city.county || "",
        city: city.city,
        zip_code: city.zip_code || "",
        extra_price: city.extra_price.toString(),
      },
    }));
  };

  // Cancel editing city
  const cancelEditingCity = (cityId) => {
    setEditingCity(null);
    setEditingCityData((prev) => {
      const newData = { ...prev };
      delete newData[cityId];
      return newData;
    });
  };

  // Update new city price for specific range
  const updateNewCityPrice = (rangeId, field, value, index = 0) => {
    const updatedData =
      addNewCityTax[rangeId]?.length > index && addNewCityTax[rangeId];
    if (!updatedData) {
      return;
    }
    updatedData[index] = {
      ...updatedData[index],
      [field]: value,
    };
    setAddNewCityTax((prev) => ({
      ...prev,
      [rangeId]: updatedData,
    }));
  };

  // Update editing range data
  const updateEditingRangeData = (rangeId, field, value) => {
    setEditingRangeData((prev) => ({
      ...prev,
      [rangeId]: {
        ...prev[rangeId],
        [field]: value,
      },
    }));
  };

  // Update editing city data
  const updateEditingCityData = (cityId, field, value) => {
    setEditingCityData((prev) => ({
      ...prev,
      [cityId]: {
        ...prev[cityId],
        [field]: value,
      },
    }));
  };
  const getCategoriesData = async () => {
    const headersFormData = {
      "Content-Type": "application/json",
      Authorization: user?.token,
    };
    try {
      let res = await axios.get(
        `${
          import.meta.env.VITE_APP_BASE_URL
        }/api/furniture-category/get-category-list-by-company`,
        { headers: headersFormData }
      );
      setCategoryList(res?.data?.data);
    } catch (err) {
      console.log("Error while getting furniture plan", err?.message);
    }
  };
  useEffect(() => {
    if (activeTab === "profile") {
      getCompanyProfiles();
    } else if (activeTab === "delivery") {
      getDeliveryRanges();
      getCategoriesData();
    } else if (activeTab === "DeliverRangeList") {
      getCompanyDeliveryRanges();
    }
  }, [activeTab, user?.token, selectedCompanyId]);

  useEffect(() => {
    if (newRange.furniture_type) {
      const nextStart = getNextRangeStartForPackage(newRange.furniture_type);
      setNewRange((prev) => ({ ...prev, min_range: nextStart.toString() }));
    } else {
      setNewRange((prev) => ({ ...prev, min_range: "0" }));
    }
  }, [newRange.furniture_type, deliveryRanges]);
  const handleCancelAddNewCityForTax = (rangeId, index) => {
    const updatedNewCitiData = addNewCityTax[rangeId]?.filter(
      (_, i) => i != index
    );
    setAddNewCityTax((prev) => ({
      ...prev,
      [rangeId]: updatedNewCitiData,
    }));
  };

  const handleChangeAddress = (index, field, value) => {
    console.log(
      "handleChangeAddress called with index:",
      index,
      "field:",
      field,
      "value:",
      value
    );

    setCompanyProfile((prev) =>
      prev.map((p, i) => (i === index ? { ...p, [field]: value } : p))
    );
  };
  const handleChange = (e) => {
    const nextValue = e.target.checked;
    setPendingValue(nextValue); // store intended value
  };

  // API call when user clicks "Yes"
  const confirmChange = async (newManualValue) => {
   setIsLoader(true);
    const newValue = pendingValue || newManualValue;
    const headersFormData = {
      "Content-Type": "application/json",
      Authorization: user?.token,
    };
    const payload = {
      is_default_delivery_fee: newValue ? 1 : 0,
      company_id: selectedCompanyId,
      ...(newValue ? { base_price: basePrice } : {}),
    };

    try {
      const res = await axios.post(
        `${
          import.meta.env.VITE_APP_BASE_URL
        }/api/company/create-byDefault-delivery`,
        payload,
        { headers: headersFormData }
      );

      if (res.data.statusCode === 200) {
        setIsManual(newValue);
        getDeliveryRanges();
        console.log("✅ Delivery mode updated successfully!");
      } else {
        console.error("Unexpected response:", res.data);
      }
    } catch (err) {
      console.error(
        "Error updating delivery mode:",
        err.response?.data?.message || err.message
      );
    }finally {
      setIsLoader(false);
    }

    setShowConfirmModal(false);
    setPendingValue(null);
    setBasePrice("");
  };

  console.log(isManual, "isManual", typeof isManual,deliveryRanges);

  // Reset if user cancels
  const cancelChange = () => {
    setPendingValue(null);
  };

  // for call city tax without click on button
  useEffect(() => {
    if (deliveryRanges.length > 0) {
      const initialized = {};
      deliveryRanges.forEach((range) => {
        initialized[range.id] = {
          min_range: range.min_range?.toString() || "",
          max_range: range.max_range?.toString() || "",
          price: range.price?.toString() || "",
          extra_fee: range.extra_fee?.toString() || "",
          furniture_type: range.furniture_type?.toString() || "",
        };
      });
      setEditingRangeData(initialized);
    }
  }, [deliveryRanges]);
  const addNewProfile = () => {
    setCompanyProfile((prev) => [...prev, blankProfile()]);
  };

  useEffect(() => {
    getCompanyProfiles();
  }, []);
  const handleSelectCompany = (e) => {
    const companyId = e;
    const filteredProfile = companyProfile.filter(
      (profile) => profile.id === companyId
    );
    setIsManual(filteredProfile[0]?.is_default_delivery_fee || 0);
    console.log("Filtered Profile:", filteredProfile);

    setSelectedCompanyId(companyId);
  };
  const LabelWithTooltip = ({ label, tooltip }) => (
    <OverlayTrigger placement="top" overlay={<Tooltip>{tooltip}</Tooltip>}>
      <span style={{ display: "inline-block" }}>
        <Form.Label
          style={{ marginBottom: 0 }}
          className="fw-semibold text-dark mb-2"
        >
          {label} <i className="fa-solid fa-circle-info"></i>
        </Form.Label>
      </span>
    </OverlayTrigger>
  );
  return (
    <Fragment>
      <div className="main-box">
        <div className="content-header d-flex justify-content-between align-items-center">
          <h3>Furniture Delivery Setup</h3>
        </div>

        {error && <Alert variant="danger">{error}</Alert>}
        {success && <Alert variant="success">{success}</Alert>}

        <div className="myfurnit_store_main ">
          {/* <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-3"> */}
          <ul
            className="nav nav-tabs d-flex justify-content-between align-items-center"
            id="myTab"
            role="tablist"
          >
            <div className="d-flex gap-2">
              {tabs.map((tab) => (
                <li className="nav-item" role="presentation" key={tab.id}>
                  <button
                    className={`nav-link ${
                      activeTab === tab.id ? "active" : ""
                    }`}
                    type="button"
                    onClick={() => setActiveTab(tab.id)}
                  >
                    {tab.name}
                  </button>
                </li>
              ))}
            </div>
            <div>
              {selectedCompanyId &&
              activeTab === "delivery" &&
              isManual == false ? (
                <Button
                  variant="primary"
                  className="d-flex align-items-center gap-2 blue-btn"
                  onClick={() => setShowAddForm(!showAddForm)}
                  title="Add new delivery range"
                >
                  <i className="fas fa-plus"></i> Add New
                </Button>
              ) : (
                ""
              )}
            </div>
          </ul>

          {/* </div> */}

          <div className="tab-content" id="myTabContent">
            <div className="tab-pane fade show active" role="tabpanel">
              {isLoader ? (
                <div className="eye-loader-frame m-5 p-5">
                  <div className="eye-loader-spinner"></div>
                </div>
              ) : (
                <>
                  {activeTab === "profile" && (
                    <div className="company-profile-form">
                      <h4>Company Profile Information</h4>
                      <div>
                        {isLoader && <Spinner animation="border" />}
                        {companyProfile.map((profile, index) => (
                          <Form
                            key={profile.id || index}
                            className="profile_information_box"
                          >
                            <Row>
                              <Col md={12}>
                                <Form.Group className="mb-3">
                                  <Form.Label>Store Name *</Form.Label>
                                  <Form.Control
                                    type="text"
                                    value={profile.company_name}
                                    onChange={(e) =>
                                      handleChangeAddress(
                                        index,
                                        "company_name",
                                        e.target.value
                                      )
                                    }
                                    placeholder="Enter company name"
                                  />
                                </Form.Group>
                              </Col>
                            </Row>

                            <div className="location-section">
                              <div className="d-flex justify-content-between align-items-start mb-3 flex-wrap gap-3">
                                <h5>Business Location</h5>
                                <div>
                                  <Button
                                    variant="outline-primary"
                                    size="sm"
                                    onClick={() => setShowMap(!showMap)}
                                  >
                                    {showMap ? "Hide Map" : "📍 Select on Map"}
                                  </Button>
                                </div>
                              </div>

                              {showMap && (
                                <>
                                  {USE_Maps ? (
                                    <GoogleMapsSelector
                                      initialLatitude={profile.latitude}
                                      initialLongitude={profile.longitude}
                                      initialAddress={profile.address}
                                      onLocationChange={(loc) =>
                                        handleLocationChange(index, loc)
                                      }
                                      onAddressChange={(addr) =>
                                        handleAddressChange(index, addr)
                                      }
                                      googleMapsApiKey={Maps_API_KEY}
                                      mapHeight="400px"
                                      className="mb-3"
                                    />
                                  ) : (
                                    <LocationSelectorMap
                                      initialLatitude={profile.latitude}
                                      initialLongitude={profile.longitude}
                                      initialAddress={profile.address}
                                      onLocationChange={(loc) =>
                                        handleLocationChange(index, loc)
                                      }
                                      onAddressChange={(addr) =>
                                        handleAddressChange(index, addr)
                                      }
                                      showDeliveryZones={
                                        deliveryRanges.length > 0
                                      }
                                      deliveryZones={deliveryRanges.map(
                                        (range) => ({
                                          min_range: range.min_range,
                                          max_range: range.max_range,
                                        })
                                      )}
                                      showAddressSearch={true}
                                      showCurrentLocation={true}
                                      showCoordinateInputs={true}
                                      mapHeight="400px"
                                      className="mb-3"
                                    />
                                  )}
                                </>
                              )}

                              {!showMap && (
                                <Row>
                                  <Col md={6}>
                                    <Form.Group className="mb-3">
                                      <Form.Label>Latitude</Form.Label>
                                      <Form.Control
                                        type="number"
                                        step="0.00000001"
                                        value={profile.latitude}
                                        onChange={(e) =>
                                          handleChangeAddress(
                                            index,
                                            "latitude",
                                            e.target.value
                                          )
                                        }
                                        placeholder="Enter latitude or select on map"
                                      />
                                    </Form.Group>
                                  </Col>
                                  <Col md={6}>
                                    <Form.Group className="mb-3">
                                      <Form.Label>Longitude</Form.Label>
                                      <Form.Control
                                        type="number"
                                        step="0.00000001"
                                        value={profile.longitude}
                                        onChange={(e) =>
                                          handleChangeAddress(
                                            index,
                                            "longitude",
                                            e.target.value
                                          )
                                        }
                                        placeholder="Enter longitude or select on map"
                                      />
                                    </Form.Group>
                                  </Col>
                                </Row>
                              )}
                            </div>

                            <Row>
                              <Col md={6}>
                                <Form.Group className="mb-3">
                                  <Form.Label>Address *</Form.Label>
                                  <Form.Control
                                    type="text"
                                    value={profile.address}
                                    onChange={(e) =>
                                      handleChangeAddress(
                                        index,
                                        "address",
                                        e.target.value
                                      )
                                    }
                                    placeholder="Enter full address"
                                  />
                                </Form.Group>
                              </Col>
                              <Col md={6}>
                                <Form.Group className="mb-3">
                                  <Form.Label>City </Form.Label>
                                  <Form.Control
                                    type="text"
                                    value={profile.city}
                                    onChange={(e) =>
                                      handleChangeAddress(
                                        index,
                                        "city",
                                        e.target.value
                                      )
                                    }
                                    placeholder="Enter city"
                                  />
                                </Form.Group>
                              </Col>
                            </Row>

                            <Row>
                              <Col md={4}>
                                <Form.Group className="mb-3">
                                  <Form.Label>State</Form.Label>
                                  <Form.Control
                                    type="text"
                                    value={profile.state}
                                    onChange={(e) =>
                                      handleChangeAddress(
                                        index,
                                        "state",
                                        e.target.value
                                      )
                                    }
                                    placeholder="Enter state"
                                  />
                                </Form.Group>
                              </Col>
                              <Col md={4}>
                                <Form.Group className="mb-3">
                                  <Form.Label>Postal Code</Form.Label>
                                  <Form.Control
                                    type="text"
                                    value={profile.postal_code}
                                    onChange={(e) =>
                                      handleChangeAddress(
                                        index,
                                        "postal_code",
                                        e.target.value
                                      )
                                    }
                                    placeholder="Enter postal code"
                                  />
                                </Form.Group>
                              </Col>
                              <Col md={4}>
                                <Form.Group className="mb-3">
                                  <Form.Label>Country</Form.Label>
                                  <Form.Control
                                    type="text"
                                    value={profile.country}
                                    onChange={(e) =>
                                      handleChangeAddress(
                                        index,
                                        "country",
                                        e.target.value
                                      )
                                    }
                                    placeholder="Enter country"
                                  />
                                </Form.Group>
                              </Col>
                            </Row>

                            <Button
                              variant="primary"
                              onClick={() => saveCompanyProfile(profile)}
                              disabled={saveLoader}
                              className="blue-btn"
                            >
                              {saveLoader ? (
                                <Spinner size="sm" />
                              ) : (
                                "Save Profile"
                              )}
                            </Button>
                            <Button
                              variant="danger"
                              style={{
                                padding: "10px 20px",
                                marginLeft: "10px",
                              }}
                              disabled={delStoreLoader}
                              onClick={() => deleteStore(profile.id)}
                            >
                              {delStoreLoader ? (
                                <Spinner size="sm" />
                              ) : (
                                "Delete"
                              )}
                            </Button>
                          </Form>
                        ))}

                        <Button className="blue-btn" onClick={addNewProfile}>
                          <i class="fas fa-plus"></i> Add new store address
                        </Button>

                        {error && <p className="text-danger mt-2">{error}</p>}
                        {success && (
                          <p className="text-success mt-2">{success}</p>
                        )}
                      </div>
                    </div>
                  )}

                  {activeTab === "delivery" && (
                    <div className="delivery-setup">
                      <div className="d-flex justify-content-between align-items-stsrt mb-4 flex-wrap gap-3">
                        <h4>Delivery Ranges</h4>
                        <Row className="align-items-center">
                          <Col md={`${selectedCompanyId ? "6" : "10"}`}>
                            <select
                              className="form-select delivery_range_select"
                              value={selectedCompanyId || ""}
                              onChange={(e) =>
                                handleSelectCompany(e.target.value)
                              }
                            >
                              <option value="">Select Store</option>
                              {companyProfile.map((company) => (
                                <option key={company.id} value={company.id}>
                                  {company.company_name}
                                </option>
                              ))}
                            </select>
                          </Col>
                          {selectedCompanyId && (
                            <Col md={6}>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "10px",
                                }}
                              >
                                <span
                                  style={{
                                    fontWeight: !isManual ? "bold" : "normal",
                                  }}
                                >
                                  Default
                                </span>

                                <Form.Check
                                  type="switch"
                                  id="mode-switch"
                                  checked={isManual}
                                  onChange={handleSwitchChange}
                                />

                                <span
                                  style={{
                                    fontWeight: isManual ? "bold" : "normal",
                                  }}
                                >
                                  Manual
                                </span>
                              </div>
                            </Col>
                          )}
                        </Row>
                      </div>

                      {!selectedCompanyId && (
                        // <Alert variant="warning" className="mb-4">
                        //   Please save your company profile first before setting
                        //   up delivery ranges.
                        // </Alert>
                        <Alert variant="warning" className="mb-4">
                          Please Select Store .
                        </Alert>
                      )}

                      {/* Current Delivery Ranges */}
                      {selectedCompanyId && deliveryRanges.length > 0 && (
                        <div className="existing-ranges">
                          {/* <h5 className="mb-3">Current Delivery Ranges</h5> */}
                          {deliveryRanges
                            .sort((a, b) => a.min_range - b.min_range)
                            .map((range, index) => {
                              if (!addNewCityTax[range.id]) {
                                setAddNewCityTax((prev) => ({
                                  ...prev,
                                  [range.id]: [initialAddNewCityTaxData],
                                }));
                              }
                              // startEditingRange(range)
                              return (
                                <div
                                  className="card-body delivery_box "
                                  style={{ padding: "20px" }}
                                >
                                  <div
                                    key={range.id}
                                    className="d-flex justify-content-between align-items-end flex-wrap gap-3"
                                  >
                                    <div className="d-flex align-items-start gap-3 flex-grow-1">
                                      <div className="flex-grow-1">
                                        <div className="range-input-expanded w-100">
                                          <Row className="g-3 align-items-end">
                                           {isManual == false && <Col col={12} md={6} lg={3}>
                                              <LabelWithTooltip
                                                label="Package"
                                                tooltip="Select the package"
                                              />
                                              <Form.Group>
                                                <Form.Select
                                                  value={
                                                    editingRangeData[range?.id]
                                                      ?.furniture_type || ""
                                                  }
                                                  onChange={(e) =>
                                                    updateEditingRangeData(
                                                      range.id,
                                                      "furniture_type",
                                                      e.target?.value
                                                    )
                                                  }
                                                  className="form-control-lg"
                                                  style={{ fontSize: "16px" }}
                                                  disabled={isManual}
                                                >
                                                  <option value="">
                                                    Choose Package
                                                  </option>
                                                  {categoryList?.map((ele) => {
                                                    return (
                                                      <option value={ele?.id}>
                                                        {ele?.name}
                                                      </option>
                                                    );
                                                  })}
                                                </Form.Select>
                                              </Form.Group>
                                            </Col>}
                                           {isManual == false && <Col col={12} md={6} lg={2}>
                                              <Form.Group>
                                                <LabelWithTooltip
                                                  label="From Miles"
                                                  tooltip="Minimum distance range for this store."
                                                />
                                                <Form.Control
                                                  type="number"
                                                  value={
                                                    editingRangeData[range.id]
                                                      ?.min_range || ""
                                                  }
                                                  onChange={(e) =>
                                                    updateEditingRangeData(
                                                      range.id,
                                                      "min_range",
                                                      e.target.value
                                                    )
                                                  }
                                                  placeholder="From"
                                                  className="form-control-lg"
                                                  style={{
                                                    fontSize: "16px",
                                                  }}
                                                  disabled={isManual}
                                                />
                                              </Form.Group>
                                            </Col>}
                                           {isManual == false && <Col col={12} md={6} lg={2}>
                                              <Form.Group>
                                                <LabelWithTooltip
                                                  label="To Miles"
                                                  tooltip="Maximum distance range for this store."
                                                />
                                                <Form.Control
                                                  type="number"
                                                  value={
                                                    editingRangeData[range.id]
                                                      ?.max_range || ""
                                                  }
                                                  onChange={(e) =>
                                                    updateEditingRangeData(
                                                      range.id,
                                                      "max_range",
                                                      e.target.value
                                                    )
                                                  }
                                                  placeholder="To"
                                                  className="form-control-lg "
                                                  style={{
                                                    fontSize: "16px",
                                                  }}
                                                  disabled={isManual}
                                                />
                                              </Form.Group>
                                            </Col>}
                                            {/* price */}
                                            <Col col={12} md={6} lg={2}>
                                              <Form.Group>
                                                <LabelWithTooltip
                                                  label="Base Price ($)"
                                                  tooltip="Base delivery cost for this distance range."
                                                />
                                                <Form.Control
                                                  type="number"
                                                  step="0.01"
                                                  value={
                                                    editingRangeData[range.id]
                                                      ?.price || ""
                                                  }
                                                  onChange={(e) =>
                                                    updateEditingRangeData(
                                                      range.id,
                                                      "price",
                                                      e.target.value
                                                    )
                                                  }
                                                  placeholder="Price"
                                                  className="form-control-lg"
                                                  style={{
                                                    fontSize: "16px",
                                                  }}
                                                  //disabled={isManual}
                                                />
                                              </Form.Group>
                                            </Col>
                                            <Col col={12} md={6} lg={3}>
                                              {/* Action buttons */}
                                              { (
                                                <div className="d-flex gap-2">
                                                  <Button
                                                    variant="success"
                                                    size="sm"
                                                    title="Save changes"
                                                    onClick={() =>
                                                      updateDeliveryRange(
                                                        range.id
                                                      )
                                                    }
                                                    disabled={saveLoader}
                                                    style={{
                                                      borderRadius: "5px",
                                                    }}
                                                    className="delivery_ranges_btn blue-btn"
                                                  >
                                                    {saveLoader ? (
                                                      <Spinner size="sm" />
                                                    ) : (
                                                      "Save"
                                                    )}
                                                  </Button>
                                                  {/* <Button
                                                    variant="outline-secondary"
                                                    size="sm"
                                                    title="Cancel editing"
                                                    onClick={() =>
                                                      cancelEditingRange(
                                                        range.id
                                                      )
                                                    }
                                                    className="delivery_ranges_btn"
                                                    style={{
                                                      borderRadius: "6px",
                                                    }}
                                                  >
                                                    Cancel
                                                  </Button> */}
                                                 {!isManual === true && (<Button
                                                    variant="outline-danger"
                                                    size="sm"
                                                    title="Delete city range"
                                                    onClick={() => {
                                                      setDeleteModal(true),
                                                        setDeleteRangeId(
                                                          range?.id
                                                        );
                                                    }}
                                                    className="delivery_ranges_btn"
                                                    style={{
                                                      borderRadius: "6px",
                                                    }}
                                                  >
                                                    Delete
                                                  </Button> ) }
                                                </div>
                                              )}
                                            </Col>
                                          </Row>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  {/* ✅ City Tax always visible */}
                                  {
                                    <div className="mt-3">
                                      <div className="d-flex justify-content-between align-items-center mb-3">
                                        {range?.cityPrices?.length > 0 ? (
                                          <h6 className="city_text">
                                            City Tax
                                          </h6>
                                        ) : null}
                                        <Button
                                          size="sm"
                                          className="d-flex align-items-center gap-2 blue-btn"
                                          title="Add city tax"
                                          onClick={() =>
                                            setAddNewCityTax((prev) => ({
                                              ...prev,
                                              [range.id]: [
                                                initialAddNewCityTaxData,
                                              ],
                                            }))
                                          }
                                        >
                                          <i className="fas fa-plus-circle"></i>{" "}
                                          Add city tax
                                        </Button>
                                      </div>

                                      <ServiceAbleAreaForExtraTax
                                        data={range.cityPrices || []}
                                        rangeId={range.id}
                                        editingCity={editingCity}
                                        editingCityData={editingCityData}
                                        startEditingCity={startEditingCity}
                                        cancelEditingCity={cancelEditingCity}
                                        updateEditingCityData={
                                          updateEditingCityData
                                        }
                                        updateCityPricing={updateCityPricing}
                                        handleDeleteCityPricing={
                                          handleDeleteCityPricing
                                        }
                                        saveLoader={saveLoader}
                                      />

                                      {/* ✅ Add City Form always open */}
                                      <div className="card border-0 bg-light mt-3">
                                        <div className="card-body bg-white">
                                          <h6 className="mb-3 d-flex align-items-center gap-2 add_city_text">
                                            <i className="fas fa-map-marker-alt"></i>
                                            Add City Tax
                                          </h6>
                                          {(
                                            addNewCityTax[range.id] || [
                                              initialAddNewCityTaxData,
                                            ]
                                          ).map((newCityPriceData, index) => (
                                            <AddServiceableAreaForTax
                                              key={index}
                                              onSave={() =>
                                                addCityPricing(range.id, index)
                                              }
                                              onCancel={() =>
                                                handleCancelAddNewCityForTax(
                                                  range?.id,
                                                  index
                                                )
                                              }
                                              newCityPrices={newCityPriceData}
                                              updateNewCityPrice={(
                                                field,
                                                value
                                              ) =>
                                                updateNewCityPrice(
                                                  range.id,
                                                  field,
                                                  value,
                                                  index
                                                )
                                              }
                                              saveLoader={saveLoader}
                                              AddServiceableAreaForTax={
                                                AddServiceableAreaForTax
                                              }
                                            />
                                          ))}
                                        </div>
                                      </div>
                                    </div>
                                  }
                                </div>
                              );
                            })}
                        </div>
                      )}

                      {selectedCompanyId && deliveryRanges.length === 0 && (
                        <div className="no-delivery-setup mb-4">
                          <Alert variant="info">
                            No delivery fees setup yet. Click "+ Add New" to add
                            your first delivery range.
                          </Alert>
                        </div>
                      )}

                      {/* Add New Range Form */}
                      {selectedCompanyId && showAddForm && (
                        <div className="card border-0 shadow-sm mb-4">
                          <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center mb-4">
                              <h5 className="mb-0 fw-bold text-black">
                                <i className="fas fa-plus"></i> Add New Delivery
                                Range
                              </h5>
                              <Button
                                variant="outline-secondary"
                                size="sm"
                                title="Close form"
                                onClick={() => setShowAddForm(false)}
                              >
                                <i className="fas fa-times"></i>
                              </Button>
                            </div>

                            {/* Range Input Form - Matching Screenshot Layout */}
                            <div className="range-input-form">
                              <Row className="g-3 align-items-end">
                                <Col col={12} md={6} lg={3}>
                                  <LabelWithTooltip
                                    label="Package"
                                    tooltip="Select the package"
                                  />
                                  <Form.Group>
                                    <Form.Select
                                      value={newRange.furniture_type}
                                      onChange={(e) =>
                                        setNewRange((prev) => ({
                                          ...prev,
                                          furniture_type: e.target.value,
                                        }))
                                      }
                                      className="form-control-lg border-2"
                                      style={{
                                        fontSize: "16px",
                                        padding: "12px 16px",
                                        borderRadius: "8px",
                                        backgroundColor:
                                          deliveryRanges.length > 0
                                            ? "#f8f9fa"
                                            : "white",
                                      }}
                                      // readOnly={deliveryRanges.length > 0}
                                    >
                                      <option value="">Select Package</option>
                                      {categoryList?.map((ele) => {
                                        return (
                                          <option value={ele?.id}>
                                            {ele?.name}
                                          </option>
                                        );
                                      })}
                                    </Form.Select>
                                  </Form.Group>
                                </Col>
                                <Col col={12} md={3}>
                                  <Form.Group>
                                    <LabelWithTooltip
                                      label="From Miles"
                                      tooltip="Select the package"
                                    />
                                    <Form.Control
                                      type="number"
                                      value={newRange.min_range}
                                      onChange={(e) =>
                                        setNewRange((prev) => ({
                                          ...prev,
                                          min_range: e.target.value,
                                        }))
                                      }
                                      disabled={packageHasPreviousRanges(
                                        newRange.furniture_type
                                      )}
                                      placeholder="0"
                                      // readOnly={deliveryRanges.length > 0}
                                      className="form-control-lg border-2"
                                      style={{
                                        fontSize: "16px",
                                        padding: "12px 16px",
                                        borderRadius: "8px",
                                        backgroundColor:
                                          deliveryRanges.length > 0
                                            ? "#f8f9fa"
                                            : "white",
                                      }}
                                    />
                                  </Form.Group>
                                </Col>
                                <Col col={12} md={3}>
                                  <Form.Group>
                                    <LabelWithTooltip
                                      label="To Miles"
                                      tooltip="Select the package"
                                    />
                                    <Form.Control
                                      type="number"
                                      value={newRange.max_range}
                                      onChange={(e) =>
                                        setNewRange((prev) => ({
                                          ...prev,
                                          max_range: e.target.value,
                                        }))
                                      }
                                      placeholder="40"
                                      className="form-control-lg border-2"
                                      style={{
                                        fontSize: "16px",
                                        padding: "12px 16px",
                                        borderRadius: "8px",
                                      }}
                                    />
                                  </Form.Group>
                                </Col>
                                <Col col={12} md={3}>
                                  <Form.Group>
                                    <LabelWithTooltip
                                      label="Base Price ($)"
                                      tooltip="Select the package"
                                    />
                                    <Form.Control
                                      type="number"
                                      step="0.01"
                                      value={newRange.price}
                                      onChange={(e) =>
                                        setNewRange((prev) => ({
                                          ...prev,
                                          price: e.target.value,
                                        }))
                                      }
                                      placeholder="50.00"
                                      className="form-control-lg border-2"
                                      style={{
                                        fontSize: "16px",
                                        padding: "12px 16px",
                                        borderRadius: "8px",
                                      }}
                                    />
                                  </Form.Group>
                                </Col>
                                {/* <Col md={3}>
                                  <Form.Group>
                                    <Form.Label className="fw-semibold text-dark mb-2">
                                      Extra Fee ($)
                                    </Form.Label>
                                    <Form.Control
                                      type="number"
                                      step="0.01"
                                      value={newRange.extra_fee}
                                      onChange={(e) =>
                                        setNewRange((prev) => ({
                                          ...prev,
                                          extra_fee: e.target.value,
                                        }))
                                      }
                                      placeholder="0.00"
                                      className="form-control-lg border-2"
                                      style={{
                                        fontSize: "16px",
                                        padding: "12px 16px",
                                        borderRadius: "8px",
                                      }}
                                    />
                                  </Form.Group>
                                </Col> */}
                              </Row>
                            </div>

                            <div className="d-flex justify-content-between align-items-center mt-4 flex-wrap gap-2">
                              <Button
                                // variant="primary"
                                size="lg"
                                onClick={addDeliveryRange}
                                disabled={
                                  saveLoader ||
                                  !newRange.min_range ||
                                  !newRange.max_range ||
                                  !newRange.price
                                }
                                className="add_city_btns"
                                title="Save range"
                                style={{
                                  borderRadius: "5px",
                                  fontWeight: "600",
                                }}
                              >
                                {saveLoader ? (
                                  <Spinner size="sm" />
                                ) : (
                                  <>
                                    <i className="fas fa-save"></i> Save Range
                                  </>
                                )}
                              </Button>
                              <small className="text-muted">
                                * Ranges must be continuous with no gaps. Next
                                range will start from{" "}
                                {getNextRangeStartForPackage()} miles.
                              </small>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                  {activeTab === "DeliverRangeList" && (
                    <DeliveryRange data={companyDeliveryRanges} />
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Delete Range Confirmation Modal */}
      <Modal
        show={deleteModal}
        onHide={() => setDeleteModal(false)}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Delivery Range</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this delivery range? This will also
          delete all associated city pricing.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setDeleteModal(false)}>
            Cancel
          </Button>
          <Button
            variant="danger"
            disabled={delLoader}
            onClick={deleteDeliveryRange}
          >
            {delLoader ? <Spinner size="sm" /> : "Delete"}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Delete City Confirmation Modal */}
      <Modal
        show={deleteCityModal}
        onHide={() => setDeleteCityModal(false)}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete City Pricing</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this city pricing?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setDeleteCityModal(false)}>
            Cancel
          </Button>
          <Button
            variant="danger"
            disabled={delLoader}
            onClick={deleteCityPricing}
          >
            {delLoader ? <Spinner size="sm" /> : "Delete"}
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Confirm Modal */}
      <Modal
        show={showConfirmModal}
        onHide={() => {
          setShowConfirmModal(false);
          setPendingValue(null);
        }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Change</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Please enter <strong>Base Price</strong> if selecting Manual mode.
          </p>

          {pendingValue && (
            <Form.Group controlId="basePriceInput" className="mt-3">
              <Form.Label>Base Price</Form.Label>
              <Form.Control
                type="number"
                placeholder="Enter base price"
                value={basePrice}
                onChange={(e) => setBasePrice(e.target.value)}
              />
            </Form.Group>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowConfirmModal(false)}
          >
            Cancel
          </Button>
          <Button variant="primary" onClick={confirmChange}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    </Fragment>
  );
};


const ServiceAbleAreaForExtraTax = ({
  data,
  rangeId,
  editingCity,
  editingCityData,
  startEditingCity,
  cancelEditingCity,
  updateEditingCityData,
  updateCityPricing,
  handleDeleteCityPricing,
  saveLoader,
}) => {
  const LabelWithTooltip = ({ label, tooltip }) => (
    <OverlayTrigger placement="top" overlay={<Tooltip>{tooltip}</Tooltip>}>
      <span style={{ display: "inline-block" }}>
        <Form.Label
          style={{ marginBottom: 0 }}
          className="fw-semibold text-dark mb-2"
        >
          {label} <i className="fa-solid fa-circle-info"></i>
        </Form.Label>
      </span>
    </OverlayTrigger>
  );

  return (
    <>
      {data.length > 0 && (
        <div className="city-list rounded p-3 mb-3">
          <div className="table-responsive table_text_no_wrap">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th scope="col">
                    <LabelWithTooltip
                      label="To City"
                      tooltip="City name where extra delivery cost applies."
                    />
                  </th>
                  <th scope="col">
                    <LabelWithTooltip
                      label="To ZIP Code"
                      tooltip="ZIP code for the city."
                    />
                  </th>
                  <th scope="col">
                    <LabelWithTooltip
                      label="To State"
                      tooltip="State of the city."
                    />
                  </th>
                  <th scope="col">
                    <LabelWithTooltip
                      label="To County"
                      tooltip="County for the selected city."
                    />
                  </th>
                  <th scope="col">
                    <LabelWithTooltip
                      label="Extra City Cost"
                      tooltip="Additional delivery charge for this city."
                    />
                  </th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                {data.map((city) =>
                  editingCity === city.id ? (
                    // EDITING ROW
                    <tr key={city.id}>
                      <td>
                        <Form.Control
                          type="text"
                          size="sm"
                          value={editingCityData[city.id]?.city || ""}
                          onChange={(e) =>
                            updateEditingCityData(city.id, "city", e.target.value)
                          }
                          placeholder="City name"
                        />
                      </td>
                      <td>
                        <Form.Control
                          type="text"
                          size="sm"
                          value={editingCityData[city.id]?.zip_code || ""}
                          onChange={(e) =>
                            updateEditingCityData(
                              city.id,
                              "zip_code",
                              e.target.value
                            )
                          }
                          placeholder="ZIP"
                        />
                      </td>
                      <td>
                        <Form.Control
                          type="text"
                          size="sm"
                          value={editingCityData[city.id]?.state || ""}
                          onChange={(e) =>
                            updateEditingCityData(city.id, "state", e.target.value)
                          }
                          placeholder="State"
                        />
                      </td>
                      <td>
                        <Form.Control
                          type="text"
                          size="sm"
                          value={editingCityData[city.id]?.county || ""}
                          onChange={(e) =>
                            updateEditingCityData(
                              city.id,
                              "county",
                              e.target.value
                            )
                          }
                          placeholder="County"
                        />
                      </td>
                      <td>
                        <Form.Control
                          type="number"
                          size="sm"
                          step="0.01"
                          value={editingCityData[city.id]?.extra_price || ""}
                          onChange={(e) =>
                            updateEditingCityData(
                              city.id,
                              "extra_price",
                              e.target.value
                            )
                          }
                          placeholder="0.00"
                        />
                      </td>
                      <td>
                        <div className="d-flex gap-1">
                          <Button
                            variant=""
                            size="sm"
                            title="Save changes"
                            onClick={() => updateCityPricing(city.id, rangeId)}
                            disabled={saveLoader}
                            className="blue-btn"
                          >
                            {saveLoader ? <Spinner size="sm" /> : "Save"}
                          </Button>
                          <Button
                            variant="outline-secondary"
                            size="sm"
                            title="Cancel editing"
                            onClick={() => cancelEditingCity(city.id)}
                          >
                            Cancel
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    // DISPLAY ROW
                    <tr key={city.id}>
                      <td scope="row">{city.city}</td>
                      <td>{city.zip_code || "-"}</td>
                      <td>{city.state || "-"}</td>
                      <td>{city.county || "-"}</td>
                      <td>+${city.extra_price}</td>
                      <td>
                        <div className="d-flex gap-1">
                          <Button
                            variant="outline-primary"
                            size="sm"
                            title="Edit city pricing"
                            onClick={() => startEditingCity(city, rangeId)}
                          >
                            <i className="fas fa-edit"></i>
                          </Button>
                          <Button
                            variant="outline-danger"
                            size="sm"
                            title="Delete city pricing"
                            onClick={() =>
                              handleDeleteCityPricing(city.id, rangeId)
                            }
                          >
                            <i className="fas fa-trash"></i>
                          </Button>
                        </div>
                      </td>
                    </tr>
                  )
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </>
  );
};



const AddServiceableAreaForTax = ({
  newCityPrices,
  onSave,
  onCancel,
  updateNewCityPrice,
  saveLoader,
}) => {
  const LabelWithTooltip = ({ label, tooltip }) => (
    <OverlayTrigger placement="top" overlay={<Tooltip>{tooltip}</Tooltip>}>
      <span style={{ display: "inline-block" }}>
        <Form.Label
          style={{ marginBottom: 0 }}
          className="fw-semibold text-dark mb-2"
        >
          {label} <i className="fa-solid fa-circle-info"></i>
        </Form.Label>
      </span>
    </OverlayTrigger>
  );
  return (
    <>
      <div className="add_city_form">
        <div className="city_form_inner">
          <Form.Group>
            <LabelWithTooltip
              label="City *"
              tooltip="City name where extra delivery cost applies."
            />
            <Form.Control
              type="text"
              placeholder="Enter city name"
              value={newCityPrices?.city || ""}
              onChange={(e) => updateNewCityPrice("city", e.target.value)}
              // className="form-control-lg"
            />
          </Form.Group>
        </div>
        <div className="city_form_inner">
          <Form.Group>
            <LabelWithTooltip
              label="ZIP Code"
              tooltip="ZIP code for the city."
            />
            <Form.Control
              type="text"
              placeholder="ZIP"
              value={newCityPrices?.zip_code || ""}
              onChange={(e) => updateNewCityPrice("zip_code", e.target.value)}
              // className="form-control-lg"
            />
          </Form.Group>
        </div>
        <div className="city_form_inner">
          <Form.Group>
            <LabelWithTooltip label="State" tooltip="State of the city." />
            <Form.Control
              type="text"
              placeholder="State"
              value={newCityPrices?.state || ""}
              onChange={(e) => updateNewCityPrice("state", e.target.value)}
              // className="form-control-lg"
            />
          </Form.Group>
        </div>
        <div className="city_form_inner">
          <Form.Group>
            <LabelWithTooltip
              label="County"
              tooltip="County for the selected city."
            />
            <Form.Control
              type="text"
              placeholder="County"
              value={newCityPrices?.county || ""}
              onChange={(e) => updateNewCityPrice("county", e.target.value)}
              // className="form-control-lg"
            />
          </Form.Group>
        </div>
        <div className="city_form_inner">
          <Form.Group>
            <LabelWithTooltip
              label="Extra City Cost ($) *"
              tooltip="Additional delivery charge for this city."
            />
            <Form.Control
              type="number"
              step="0.01"
              placeholder="0.00"
              value={newCityPrices?.extra_price || ""}
              onChange={(e) =>
                updateNewCityPrice("extra_price", e.target.value)
              }
              // className="form-control-lg"
            />
          </Form.Group>
        </div>
        <div className="city_form_inner">
          <div className="d-flex w-100 gap-2 add_city_btns h-100 align-items-end">
            <Button
              variant=""
              size="lg"
              title="Save city pricing"
              onClick={() => onSave()}
              disabled={saveLoader}
              className="d-flex align-items-center justify-content-center blue-btn add_city_btn"
            >
              {saveLoader ? (
                <Spinner size="sm" />
              ) : (
                // <i className="fas fa-save"></i>
                "  Save"
              )}
            </Button>
            <Button
              variant="outline-secondary"
              size="lg"
              title="Cancel"
              onClick={() => {
                onCancel();
              }}
              className="d-flex align-items-center justify-content-center add_city_btn"
            >
              {/* <i className="fas fa-times"></i> */}
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

const DeliveryRange = ({ data }) => {
  return (
    <div className="table-responsive table_text_no_wrap">
      <table className="table table-hover m-0">
        <thead>
          <tr>
            <th>Store</th>
            <th>Package</th>
            <th>State</th>
            <th>County</th>
            <th>City Served</th>
            <th>Zip Code</th>
            <th>Extra Price</th>
          </tr>
        </thead>
        <tbody>
          {data.map((company) => {
            const companyName = company.company_name || "-";
            const companyState = company.state || company.country || "-";
            const companyPostal = company.postal_code || "-";

            if (!company.ranges || company.ranges.length === 0) {
              return (
                <tr key={`company-${company.id}-noranges`}>
                  <td>{companyName}</td>
                  <td>-</td>
                  <td>{companyState}</td>
                  <td>{company.city || "-"}</td>
                  <td>{companyPostal}</td>
                  <td>-</td>
                  <td>-</td>
                </tr>
              );
            }

            return company.ranges.map((range) => {
              const packageName = range.furniture_category_name || "N/A";

              if (
                Array.isArray(range.cityPrices) &&
                range.cityPrices.length > 0
              ) {
                return range.cityPrices.map((city) => (
                  <tr key={`${company.id}-${range.id}-${city.id}`}>
                    <td>{companyName}</td>
                    <td>{packageName}</td>
                    <td>{city.state || companyState || "-"}</td>
                    <td>{city.county || "-"}</td>
                    <td>{city.city || "-"}</td>
                    <td>{city.zip_code || "-"}</td>
                    <td>{city.extra_price ? `$${city.extra_price}` : "-"}</td>
                  </tr>
                ));
              } else {
                return (
                  <tr key={`${company.id}-${range.id}-nocity`}>
                    <td>{companyName}</td>
                    <td>{packageName}</td>
                    <td>{companyState}</td>
                    <td>{company.city || "-"}</td>
                    <td>{companyPostal}</td>
                    <td>{range.extra_fee ? `+$${range.extra_fee}` : "-"}</td>
                    <td>-</td>
                  </tr>
                );
              }
            });
          })}
        </tbody>
      </table>
    </div>
  );
};

export default FurnitureDeliverySetup;
